const Strings = Object.freeze({
  PORTUGUESE: "Português",
  ENGLISH: "English",
  SPANISH: "Español",
  DATE_LOCALE: "es-ES",
  CURRENT_VALUE_DP: "Valor actual: ",
  MILLISECONDS_SUFFIX: " ms",
  KILOBITS_PER_SECOND_SUFFIX: " Kbps",
  MEGABITS_PER_SECOND_SUFFIX: " Mbps",
  TENDENCY_AND: " y ",
  TS_MONITOR_LOGO_ALT: "Logotipo de TS Monitor",
  TENDENCY_GOOD_PING_LIMIT: "< 16 ms",
  TENDENCY_WARNING_PING_LIMIT: "≥ 16 ms",
  TENDENCY_WARNING_UPPER_PING_LIMIT: "< 26 ms",
  TENDENCY_BAD_PING_LIMIT: "> 26 ms",
  NETWORK_IP_PLACEHOLDER: "192.168.0.2",
  NETWORK_MASK_PLACEHOLDER: "255.255.255.0",
  NETWORK_GATEWAY_PLACEHOLDER: "192.168.0.1",
  DHCP_PLACEHOLDER: "DHCP",
  SWEEP_FIRST_BAND_PLACEHOLDER: "192.168.2",
  SWEEP_SECOND_BAND_PLACEHOLDER: "192.168.3",
  SWEEP_THIRD_BAND_PLACEHOLDER: "192.168.4",
  SWEEP_FOURTH_BAND_PLACEHOLDER: "192.168.5",
  SWEEP_FIFTH_BAND_PLACEHOLDER: "192.168.6",
  SWEEP_BEGINNING_PLACEHOLDER: "0",
  SWEEP_END_PLACEHOLDER: "255",
  PING_LIMIT_PLACEHOLDER: "200",
  PACKET_LOSS_RATE_PLACEHOLDER: "42",
  MILLISECONDS_UNIT: "ms",
  PERCENTAGE_UNIT: "%",


  //  ---------------------------- Live List ----------------------------
  CONFIG_METHOD_1: "Método de",
  CONFIG_METHOD_2: "configuración",
  LOST_PACKET_PERC_1: "Pings",
  LOST_PACKET_PERC_2: "perdidos (%)",
  TENDENCY: "Tendencia",
  AVAILABILITY: "Disponibilidad",
  STATUS: "Status",

  OFFLINE_STRING: "Offline",
  ONLINE_STRING: "Online",
  FAULT_STRING: "Falla",

  LIVE_LIST_OK_POPUP_TEXT: "Dispositivo EtherNet/IP en operación normal, es decir, intercambiando datos.",
  LIVE_LIST_FAULT_POPUP_TEXT: "Dispositivo EtherNet/IP que estuvo en modo de operación normal (OK), pero ya no está comunicándose en la red.",
  LIVE_LIST_ONLINE_POPUP_TEXT: "Dispositivo activo en la red que no intercambia datos del protocolo EtherNet/IP.",
  LIVE_LIST_OFFLINE_POPUP_TEXT: "Dispositivo no EtherNet/IP que estuvo activo en la red (Online), pero que ya no es accesible por el monitor.",

  ETHERNET_IP: "EtherNet/IP",

  INSUFFICIENT_DATA: "Sin datos suficientes",


  EXPORT_CSV: "Exportar XLSX",

  IP_POPUP_1: "La celda IP de un dispositivo tendrá fondo violeta si su IP está duplicada, como en el ejemplo a continuación.",
  IP_POPUP_2: "Si el dispositivo pierde su dirección IP, tendrá fondo naranja, como en el ejemplo a continuación.",
  IP_POPUP_3: "Además, al hacer clic en la celda es posible eliminar el dispositivo, si así lo desea.",

  CONFIG_METHOD_POPUP_1: "Determina cómo el dispositivo deberá obtener sus configuraciones de IP.",

  CONFIG_METHOD_POPUP_2: "El valor (0) indica que el dispositivo deberá obtener sus configuraciones de IP de forma estática.",
  CONFIG_METHOD_POPUP_3: "El valor (1) indica que el dispositivo deberá obtener sus configuraciones de IP vía BOOTP.",
  CONFIG_METHOD_POPUP_4: "El valor (2) indica que el dispositivo deberá obtener sus configuraciones de IP vía DHCP.",
  CONFIG_METHOD_POPUP_5: "Los valores (3-15) están reservados para uso futuro.",

  CONFIG_METHOD_POPUP_6: "Si el método es DHCP, la celda quedará como en el ejemplo a continuación.",

  MISSED_PINGS_POPUP: "Cantidad / % de pings perdidos en los últimos 360 pings realizados.",

  NETWORK_AVAILABILITY_DP: "Disponibilidad de la red: ",

  LIVE_LIST_CSV_HEADER: "IP,MAC,Protocolo,Método de configuración,Ping actual (ms),Ping promedio (ms),Pings perdidos,Pings perdidos (%),Disponibilidad,Status\n",
  LIVE_LIST_CSV_EXPORT_NAME: "Live List.xlsx",
  TENDENCY_POPUP_1: "La barra de tendencia está dividida en 9 partes, cada una de ellas comprende una porción de las últimas 360 respuestas de ping (como máximo).",
  TENDENCY_POPUP_2: "Solo se consideran los pings de paquetes que no se perdieron.",
  TENDENCY_POPUP_3: "• Si todos los pings de la parte son ",
  TENDENCY_POPUP_4: " se pintará de verde.",
  TENDENCY_POPUP_5: "• Si algún ping de la parte es ",
  TENDENCY_POPUP_6: " se pintará de amarillo.",
  TENDENCY_POPUP_7: "• Si algún ping de la parte es ",
  TENDENCY_POPUP_8: " se pintará de rojo.",

  // ---------------------------- Inventory ----------------------------
  PRODUCT_NAME_POPUP_1: "Es una breve descripción del producto, representado por el product code.",
  PRODUCT_NAME_POPUP_2: "Un mismo product code puede tener una variedad de nombres de producto.",
  PRODUCT_NAME_POPUP_3: "El número máximo de caracteres para un nombre de producto es 32.",

  VENDOR_ID_POPUP_1: "Los valores de 'Vendor ID' son gestionados por la ODVA.",
  VENDOR_ID_POPUP_2: "El valor cero (0) no se considera válido.",

  REVISION_POPUP_1: "La revisión consiste en dos valores: Major y Minor.",
  REVISION_POPUP_2: "Los valores Major y Minor se presentan típicamente como major.minor (ej.: 3.15).",

  PRODUCT_CODE_1: "El Product Code asignado por el fabricante identifica un producto particular dentro de un tipo de dispositivo.",
  PRODUCT_CODE_2: "Cada fabricante asigna este código a cada uno de sus productos. Típicamente se mapea a uno o más números de catálogo / modelos.",
  PRODUCT_CODE_3: "Los productos deben tener códigos diferentes si su configuración y / o sus opciones de tiempo de ejecución son diferentes.",
  PRODUCT_CODE_4: "El valor cero no es válido.",

  SERIAL_NUMBER_POPUP_1: "El serial number se usa junto con el Vendor ID para formar un identificador único para cada dispositivo de la red.",
  SERIAL_NUMBER_POPUP_2: "Cada proveedor / fabricante es responsable de garantizar la exclusividad del serial number en todos sus dispositivos.",
  SERIAL_NUMBER_POPUP_3: "Cero (0) no es un valor válido de serial number y no debe asignarse a ningún producto ni ser reportado por ningún dispositivo.",
  SERIAL_NUMBER_POPUP_4: "La recepción del valor cero (0) al acceder a este atributo indica que el dispositivo no posee serial number.",

  DEVICE_TYPE_POPUP_1: "El valor tipo de dispositivo se usa para identificar el device profile que el producto está utilizando.",
  DEVICE_TYPE_POPUP_2: "Los profiles definen los requisitos mínimos que el dispositivo debe implementar, así como opciones comunes.",
  DEVICE_TYPE_POPUP_3: "La lista pública de device profiles es gestionada por la ODVA.",

  NUM_OF_DEVICES: "Cantidad de dispositivos encontrados: ",

  INVENTORY_CSV_EXPORT_NAME: "Inventario.xlsx",
  INVENTORY_CSV_HEADER: "IP,MAC,Nombre del producto,Vendor ID,Revisión,Product Code,Serial Number,Tipo de dispositivo\n",

  //  ---------------------------- PORTS ----------------------------
  PRODUCT_NAME_1: "Nombre",
  PRODUCT_NAME_2: "del",
  PRODUCT_NAME_3: "producto",

  INTERFACE_TYPE_1: "Tipo de",
  INTERFACE_TYPE_2: "interfaz",

  DUPLEX_MODE_1: "Modo",
  DUPLEX_MODE_2: "Duplex",

  INTERFACE_SPEED_1: "Velocidad",
  INTERFACE_SPEED_2: "de la interfaz",

  NEGOTIATION_STATUS_1: "Estado de",
  NEGOTIATION_STATUS_2: "negociación",

  HARDWARE_FAULT_1: "Falla de",
  HARDWARE_FAULT_2: "hardware local",

  INTERFACE_STATUS_1: "Estado de la",
  INTERFACE_STATUS_2: "interfaz",

  LINK_STATUS_1: "Estado",
  LINK_STATUS_2: "del enlace",

  INTERFACE_TYPE_POPUP_1: "El valor (0) indica que el tipo de interfaz es desconocido.",
  INTERFACE_TYPE_POPUP_2: "El valor (1) indica que la interfaz es interna al dispositivo.",
  INTERFACE_TYPE_POPUP_3: "El valor (2) indica que la interfaz es de par trenzado (ej., 10Base-T, 100Base-TX, 1000Base-T, etc.).",
  INTERFACE_TYPE_POPUP_4: "El valor (3) indica que la interfaz es de fibra óptica (ej., 100Base-FX).",
  INTERFACE_TYPE_POPUP_5: "Los valores (4-256) están reservados.",
  INTERFACE_TYPE_POPUP_6: "Cuando el valor sea 'Sin respuesta' significa que no fue posible determinar el tipo de interfaz.",

  DUPLEX_MODE_POPUP_1: "El valor (0) indica que el puerto está en modo half duplex.",
  DUPLEX_MODE_POPUP_2: "El valor (1) indica que el puerto está en modo full duplex.",
  DUPLEX_MODE_POPUP_3: "Si el estado del enlace es inactivo o desconocido, entonces el modo duplex es indeterminado.",

  INTERFACE_SPEED_POPUP_1: "Indica la velocidad a la que está funcionando la interfaz.",
  INTERFACE_SPEED_POPUP_2: "El valor (0) indica que la velocidad de la interfaz no puede determinarse.",
  INTERFACE_SPEED_POPUP_3: "La velocidad de la interfaz tiene como objetivo representar el ancho de banda; el atributo no se duplica si la interfaz está en modo full-duplex.",

  NEGOTIATION_STATUS_POPUP_1: "El valor (0) indica que la auto negociación está en progreso.",
  NEGOTIATION_STATUS_POPUP_2: "El valor (1) indica que la auto negociación y la detección de velocidad fallaron. Se están utilizando valores predeterminados de velocidad y modo duplex. Estos valores son específicos de cada producto (se recomiendan 10 Mbps y half duplex).",
  NEGOTIATION_STATUS_POPUP_3: "El valor (2) indica que la auto negociación falló, pero la velocidad fue detectada. Se eligió un valor predeterminado para el modo duplex. Este valor es específico de cada producto (se recomienda half duplex).",
  NEGOTIATION_STATUS_POPUP_4: "El valor (3) indica que la velocidad y el modo duplex fueron negociados con éxito.",
  NEGOTIATION_STATUS_POPUP_5: "El valor (4) indica que la autonegociación no fue intentada. Se forzaron valores predeterminados de velocidad y modo duplex.",

  LOCAL_HARDWARE_FAULT_POPUP_1: "El valor (0) indica que en este puerto no se detectó ninguna falla de hardware local.",
  LOCAL_HARDWARE_FAULT_POPUP_2: "El valor (1) indica que se detectó una falla de hardware local. Este valor tiene un significado específico para cada producto, pero se asume que este tipo de error requiere algún tipo de intervención del usuario para ser corregido.",

  INTERFACE_STATUS_POPUP_1: "El valor (0) indica que el estado de la interfaz es desconocido.",
  INTERFACE_STATUS_POPUP_2: "El valor (1) indica que la interfaz está habilitada y lista para enviar y recibir datos.",
  INTERFACE_STATUS_POPUP_3: "El valor (2) indica que la interfaz está deshabilitada.",
  INTERFACE_STATUS_POPUP_4: "El valor (3) indica que la interfaz está en prueba.",
  INTERFACE_STATUS_POPUP_5: "Los valores (4-256) están reservados.",
  INTERFACE_STATUS_POPUP_6: "Cuando el valor sea 'Sin respuesta' significa que no fue posible determinar el estado de la interfaz.",

  LINK_STATUS_POPUP_1: "Indica si la interfaz de comunicación está conectada a una red activa. La determinación del estado del enlace es específica de cada implementación.",
  LINK_STATUS_POPUP_2: "En algunos casos, el dispositivo puede indicar si el enlace está activo mediante soporte del hardware / driver.",
  LINK_STATUS_POPUP_3: "En otros casos, el dispositivo puede solo ser capaz de decir si el enlace está activo por la presencia de paquetes entrantes.",

  PORTS_FILTER_LABEL: "Filtro de puertos",
  PORTS_FILTER_POPUP_1: "Algunos dispositivos presentan pérdidas de paquete en puertos internos para los cuales no hay acción correctiva posible por parte del usuario, y no aportan información relevante para el análisis de la red en sí.",
  PORTS_FILTER_POPUP_2: "El filtro elimina estos puertos; sin embargo, puertos con nombres inusuales pueden ser eliminados y, por este motivo, el filtro puede desactivarse para permitir la visualización completa.",

  ARE_YOU_SURE_YOU_WANT: "¿Está seguro de que desea ",
  THE_PORTS_FILTER: " el filtro de puertos?",

  TURN_ON: "encender",
  TURN_OFF: "apagar",

  PORTS_FILTER_TURN_ON_FAILURE: "Ocurrió un error al encender el filtro de puertos.",
  PORTS_FILTER_TURN_OFF_FAILURE: "Ocurrió un error al apagar el filtro de puertos.",

  SHOW_ONLY_ERROR_DEVICES: "Mostrar solo dispositivos con errores",

  //  ---------------------------- NETWORK ----------------------------
  NETWORK_TOPOLOGY_1: "Topología",
  NETWORK_TOPOLOGY_2: "de la",
  NETWORK_TOPOLOGY_3: "red",

  NETWORK_STATUS_1: "Estado",
  NETWORK_STATUS_2: "de la",
  NETWORK_STATUS_3: "red",

  ADDRESS_CONFLICT_DETECTION: "Address Conflict Detection",
  RING_CAPABILITY_FLAGS: "Ring Capability Flags",

  ACD_CAPABLE_1: "ACD",
  ACD_CAPABLE_2: "capable",

  ACD_STATUS_1: "ACD",
  ACD_STATUS_2: "status",

  ANNOUNCE_BASED_RING_NODE_1: "Announce-based",
  ANNOUNCE_BASED_RING_NODE_2: "Ring Node",

  BEACON_BASED_RING_NODE_1: "Beacon-based",
  BEACON_BASED_RING_NODE_2: "Ring Node",

  FLUSH_TABLE_CAPABLE_1: "Flush Table",
  FLUSH_TABLE_CAPABLE_2: "Frame Capable",

  REDUNDANT_GATEWAY_CAPABLE_1: "Redundant Gateway",
  REDUNDANT_GATEWAY_CAPABLE_2: "Capable",

  SUPERVISOR_CAPABLE_1: "Supervisor",
  SUPERVISOR_CAPABLE_2: "Capable",

  NETWORK_TOPOLOGY_POPUP_1: "Modo actual de la topología de la red.",
  NETWORK_TOPOLOGY_POPUP_2: "El valor (0) indica que la topología es Lineal.",
  NETWORK_TOPOLOGY_POPUP_3: "El valor (1) indica que la topología es en Anillo (Ring).",
  NETWORK_TOPOLOGY_POPUP_4: "El valor 'Sin respuesta' indica que no fue posible determinar la topología de la red.",

  NETWORK_STATUS_POPUP_1: "Indica el estado actual de la red según la visión que el dispositivo tiene de la red.",
  NETWORK_STATUS_POPUP_2: "El valor (0 - Normal) indica que la red está operando normalmente, tanto en modo Anillo (Ring) como en modo Lineal.",
  NETWORK_STATUS_POPUP_3: "El valor (1 - Ring Fault) indica que se detectó una falla de anillo. Este valor solo es válido cuando la topología de la red es en Anillo.",
  NETWORK_STATUS_POPUP_4: "El valor (2 - Unexpected Loop Detected) indica que se detectó un loop en la red. Este valor solo es válido cuando la topología de la red es Lineal.",
  NETWORK_STATUS_POPUP_5: "El valor (3 - Partial Network Fault) indica que se detectó una falla de red en una sola dirección. Este valor es válido solo cuando la topología de la red es en Anillo y el nodo que reporta es el ring supervisor activo.",
  NETWORK_STATUS_POPUP_6: "El valor (4 - Rapid Fault/Restore Cycle) indica que se detectó una serie de rápidos ciclos de ring fault/restore. Este valor es válido solo para el DLR Supervisor.",
  NETWORK_STATUS_POPUP_7: "El valor 'Sin respuesta' indica que no fue posible determinar el estado actual de la red.",

  ACD_CAPABLE_POPUP_1: "El valor 'Sí' indica que el dispositivo es capaz de detectar conflictos de dirección.",
  ACD_CAPABLE_POPUP_2: "El valor 'No' indica que el dispositivo no es capaz de detectar conflictos de dirección.",

  ACD_STATUS_POPUP_1: "Indica cuando se detecta un conflicto de dirección IP por el ACD.",
  ACD_STATUS_POPUP_2: "De forma predeterminada, el valor 0 (false) deberá definirse durante la inicialización del dispositivo.",
  ACD_STATUS_POPUP_3: "Si ACD es soportado y está encendido, entonces el valor se definirá como 1 (true) siempre que se detecte un conflicto de dirección.",

  ANNOUNCE_BASED_RING_NODE_POPUP_1: "El valor 'Sí' indica que la implementación ring node del dispositivo se basa en el procesamiento de Announce frames.",
  ANNOUNCE_BASED_RING_NODE_POPUP_2: "El valor 'No' indica que la implementación no se basa en el procesamiento de Announce frames.",
  ANNOUNCE_BASED_RING_NODE_POPUP_3: "El valor 'Sin respuesta' indica que no fue posible determinar el valor de esta flag.",

  BEACON_BASED_RING_NODE_POPUP_1: "El valor 'Sí' indica que la implementación ring node del dispositivo se basa en el procesamiento de Beacon frames.",
  BEACON_BASED_RING_NODE_POPUP_2: "El valor 'No' indica que la implementación no se basa en el procesamiento de Beacon frames.",
  BEACON_BASED_RING_NODE_POPUP_3: "El valor 'Sin respuesta' indica que no fue posible determinar el valor de esta flag.",

  FLUSH_TABLE_CAPABLE_POPUP_1: "El valor 'Sí' indica que el dispositivo es capaz de procesar Flush_Table frames.",
  FLUSH_TABLE_CAPABLE_POPUP_2: "El valor 'No' indica que el dispositivo no es capaz de procesar Flush_Table frames.",
  FLUSH_TABLE_CAPABLE_POPUP_3: "El valor 'Sin respuesta' indica que no fue posible determinar el valor de esta flag.",

  REDUNDANT_GATEWAY_CAPABLE_POPUP_1: "El valor 'Sí' indica que el dispositivo es capaz de proporcionar la función de gateway redundante.",
  REDUNDANT_GATEWAY_CAPABLE_POPUP_2: "El valor 'No' indica que el dispositivo no es capaz de proporcionar la función de gateway redundante.",
  REDUNDANT_GATEWAY_CAPABLE_POPUP_3: "El valor 'Sin respuesta' indica que no fue posible determinar el valor de esta flag.",

  SUPERVISOR_CAPABLE_POPUP_1: "El valor 'Sí' indica que el dispositivo es capaz de proporcionar la función de supervisor.",
  SUPERVISOR_CAPABLE_POPUP_2: "El valor 'No' indica que el dispositivo no es capaz de proporcionar la función de supervisor.",
  SUPERVISOR_CAPABLE_POPUP_3: "El valor 'Sin respuesta' indica que no fue posible determinar el valor de esta flag.",

  //  ---------------------------- TOPOLOGY ----------------------------
  TOPOLOGY_POPUP_1: "Algunos dispositivos de esta pantalla pueden aparecer sin puertos. Esto suele ocurrir cuando:",
  TOPOLOGY_POPUP_2: "El dispositivo no responde a consultas SNMP; o",
  TOPOLOGY_POPUP_3: "SNMP está deshabilitado en el dispositivo.",

  SNMP_POPUP_1: "Esta columna indica qué dispositivos responden a consultas SNMP y puede tener dos valores:",
  SNMP_POPUP_2: "Cuando el dispositivo responde a consultas SNMP;",
  SNMP_POPUP_3: "Cuando el dispositivo no responde a consultas SNMP.",

  //  ---------------------------- Media Counters ----------------------------

  ALIGNMENT_ERRORS_1: "Alignment",
  ALIGNMENT_ERRORS_2: "Errors",

  CARRIER_SENSE_ERRORS_1: "Carrier",
  CARRIER_SENSE_ERRORS_2: "Sense Errors",

  FCS_ERRORS_1: "FCS",
  FCS_ERRORS_2: "Errors",

  SINGLE_COLLISIONS_1: "Single",
  SINGLE_COLLISIONS_2: "Collisions",

  MULTIPLE_COLLISIONS_1: "Multiple",
  MULTIPLE_COLLISIONS_2: "Collisions",

  LATE_COLLISIONS_1: "Late",
  LATE_COLLISIONS_2: "Collisions",

  EXCESSIVE_COLLISIONS_1: "Excessive",
  EXCESSIVE_COLLISIONS_2: "Collisions",

  SQE_TEST_ERRORS_1: "SQE",
  SQE_TEST_ERRORS_2: "Test",
  SQE_TEST_ERRORS_3: "Errors",

  DEFERRED_TRANSMISSION_1: "Deferred",
  DEFERRED_TRANSMISSION_2: "Transmission",

  FRAME_TOO_LONG_1: "Frame",
  FRAME_TOO_LONG_2: "Too",
  FRAME_TOO_LONG_3: "Long",

  MAC_TRANSMIT_ERRORS_1: "MAC",
  MAC_TRANSMIT_ERRORS_2: "Transmit",
  MAC_TRANSMIT_ERRORS_3: "Errors",

  MAC_RECEIVE_ERRORS_1: "MAC",
  MAC_RECEIVE_ERRORS_2: "Receive",
  MAC_RECEIVE_ERRORS_3: "Errors",

  ALIGNMENT_ERRORS_POPUP: "Representa el número de frames recibidos que no terminan con un número par de octetos y poseen algún problema de CRC.",

  FCS_ERRORS_POPUP_1: "Representa el número de frames recibidos con checksum incorrecto (valor CRC) en el frame Ethernet.",
  FCS_ERRORS_POPUP_2: "Estos frames son descartados y no se propagan a otros puertos.",

  EXCESSIVE_COLLISIONS_POPUP_1: "El contador de colisiones excesivas se incrementa después de que ocurren 16 Late Collisions consecutivas en secuencia.",
  EXCESSIVE_COLLISIONS_POPUP_2: "Después de 16 intentos de enviar el paquete, este es descartado y el contador se incrementa.",

  DEFERRED_TRANSMISSION_POPUP_1: "Número total de frames cuyo primer intento de transmisión fue retrasado debido al tráfico de la red.",
  DEFERRED_TRANSMISSION_POPUP_2: "Este total incluye solo los frames que posteriormente se transmiten sin errores y sin colisiones.",

  LATE_COLLISION_POPUP_1: "Una late collision ocurre cuando dos dispositivos transmiten al mismo tiempo y ninguno de los dos lados de la conexión detecta la colisión.",
  LATE_COLLISION_POPUP_2: "Esto ocurre porque el tiempo de propagación de la señal de un extremo de la red al otro es mayor que el tiempo de colocar el paquete completo en la red. Los dos dispositivos que causan la late collision solo descubren que el otro está enviando después de haber colocado el paquete completo en la red.",
  LATE_COLLISION_POPUP_3: "Las late collisions no son detectadas por el transmisor antes del primer slot de 64 bytes. Esto ocurre porque solo se detectan en transmisiones de paquetes mayores de 64 bytes.",

  FRAME_TOO_LONG_POPUP: "El número de paquetes de entrada que exceden el tamaño máximo del paquete Ethernet.",

  MAC_TRANSMIT_ERRORS_POPUP: "Frames para los cuales la transmisión falla debido a un error interno de transmisión de la subcapa MAC.",
  MAC_RECEIVE_ERRORS_POPUP: "Frames para los cuales la recepción en la interfaz Ethernet falló debido a un error interno de recepción de la subcapa MAC.",

  IMPORTARNT_DP: "IMPORTANTE: ",
  SQE_TEST_ERRORS_POPUP_1: "Una prueba para detectar colisiones presentes en el circuito entre el transceiver y la tarjeta de interfaz de red (NIC - Network interface card).",
  SQE_TEST_ERRORS_POPUP_2: "Debido a que la mayor parte de las NIC hoy en día poseen un transceiver integrado, la prueba de SQE es innecesaria.",
  SQE_TEST_ERRORS_POPUP_3: "Ignore este media counter.",

  CARRIER_SENSE_ERRORS_POPUP: "Cantidad de veces que la condición de carrier sense se perdió o nunca fue asegurada al intentar transmitir un frame.",

  SINGLE_COLLISION_POPUP: "Número de paquetes de salida que sufrieron solo una colisión durante la transmisión.",
  MULTIPLE_COLLISIONS_POPUP: "Número de paquetes de salida que sufrieron más de una colisión durante la transmisión.",

  //  ---------------------------- Interface Counters ----------------------------
  INPUT: "Entrada",
  OUTPUT: "Salida",

  IN_OCTETS_1: "In",
  IN_OCTETS_2: "Octets",

  IN_UCAST_PACKETS_1: "In",
  IN_UCAST_PACKETS_2: "Ucast Packets",

  IN_NUCAST_PACKETS_1: "In",
  IN_NUCAST_PACKETS_2: "NUcast Packets",

  IN_DISCARDS_1: "In",
  IN_DISCARDS_2: "Discards",

  IN_ERRORS_1: "In",
  IN_ERRORS_2: "Errors",

  IN_UNKNOWN_PROTOS_1: "In",
  IN_UNKNOWN_PROTOS_2: "Unknown Protos",

  OUT_OCTETS_1: "Out",
  OUT_OCTETS_2: "Octets",

  OUT_UCAST_PACKETS_1: "Out",
  OUT_UCAST_PACKETS_2: "Ucast Packets",

  OUT_NUCAST_PACKETS_1: "Out",
  OUT_NUCAST_PACKETS_2: "NUcast Packets",

  OUT_DISCARDS_1: "Out",
  OUT_DISCARDS_2: "Discards",

  OUT_ERRORS_1: "Out",
  OUT_ERRORS_2: "Errors",

  IN_OCTETS_POPUP: "Número total de octetos recibidos en la interfaz.",
  IN_UCAST_POPUP: "Número de paquetes unicast entregados a un protocolo de capa superior.",
  IN_NUCAST_POPUP: "Número de paquetes no unicast (broadcast o multicast) entregados a un protocolo de capa superior.",
  IN_DISCARDS_POPUP: "Número total de frames de entrada cuyo intento de transmisión fue abandonado debido a recursos insuficientes.",
  IN_ERRORS_POPUP: "Número de paquetes de entrada que contenían errores que impedían que fueran entregados a un protocolo de capa superior.",
  IN_UNKNOWN_PROTOS_POPUP: "Número de paquetes recibidos a través de la interfaz que fueron descartados debido a un protocolo desconocido o no soportado.",

  OUT_OCTETS_POPUP: "El número total de octetos transmitidos hacia fuera de la interfaz.",
  OUT_UCAST_POPUP: "El número total de paquetes que los protocolos de nivel superior solicitaron transmitir a una dirección unicast de subred, incluidos aquellos que fueron descartados o no enviados.",
  OUT_NUCAST_POPUP: "El número total de paquetes que los protocolos de nivel superior solicitaron transmitir a una dirección no unicast (broadcast o multicast), incluidos aquellos que fueron descartados o no enviados.",
  OUT_DISCARDS_POPUP: "Número total de frames de salida cuyo intento de transmisión fue abandonado debido a recursos insuficientes.",
  OUT_ERRORS_POPUP: "El número de paquetes de salida que no pudieron transmitirse debido a errores.",

  //  ---------------------------- Log ----------------------------
  LOG_CSV_EXPORT_NAME: "Log.xlsx",
  LOG_CSV_HEADER: "Horario,IP,MAC,Nombre del producto,Tipo,Evento\n",

  //  ---------------------------- Ping Graph ----------------------------
  DEVICES: "Dispositivos",
  DEVICES_TOOLTIP_1: "Es posible visualizar como máximo 5 dispositivos al mismo tiempo.",
  DEVICES_TOOLTIP_2: "Los dispositivos con IP duplicada no se muestran mientras el problema no sea solucionado.",
  TIME_DP: "Tiempo: ",
  TIME: "Tiempo",

  //  ---------------------------- Device Status ----------------------------

  // ---------------------------- Page Scaling Modifiers ----------------------------

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "Ocurrió un error al iniciar sesión: nombre de usuario o contraseña incorrectos.",
  LOGIN_GENERAL_FALIURE: "Ocurrió un error al iniciar sesión:",
  LOGIN: "LOGIN",
  USERNAME: "Usuario",
  PASSWORD: "Contraseña",
  NEW_PASSWORD: "Nueva contraseña",
  REPEAT_PASSWORD: "Repetir contraseña",
  ENTER: "Iniciar sesión",
  LOGOUT: "Cerrar sesión",
  HOSTNAME: "Hostname",
  TIMEZONE: "Zona horaria",
  SOFTWARE_UPDATE: "Actualización de software",
  CURRENT_VERSION: "Versión actual: ",
  REPORT: "Informe",
  CHANGE_LOGIN: "Cambiar inicio de sesión",
  CHANGE: "Cambiar",
  UPDATE: "Actualizar",

  GPG_ALERT_MESSAGE: "Solo se pueden enviar archivos con la extensión .gpg.",

  SEND_FILE_SUCCESS: "El archivo se envió correctamente.",
  SEND_FILES_SUCCESS: "Los archivos se enviaron correctamente.",
  SEND_FILE_SUCCESS_WARNING: "Recuerde comprobar si el adaptador de red de su computadora está en la misma subred que la IP: ",
  SEND_FILE_FAILURE: "Ocurrió un error al enviar el archivo.",
  SEND_FILES_FAILURE: "Ocurrió un error al enviar los archivos.",
  SEND_FILE_WAITING: "Enviando el archivo.",
  SEND_FILES_WAITING: "Enviando los archivos.",
  SEND_FILE_WRONG_FILENAME: "Nombre de archivo no válido. El archivo de actualización debe llamarse: updateEthIP.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "El archivo de actualización se dañó durante la carga.",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocurrió un error al enviar los siguientes archivos GSDML: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocurrió un error al eliminar los siguientes archivos GSDML: ",
  SEND_CONFIG_SUCCESS: "La configuración se envió correctamente.",
  SEND_CONFIG_FAILURE: "Ocurrió un error al enviar la configuración.",
  SEND_CONFIG_WAITING: "Enviando la configuración.",
  SEND_CONFIG_WAITING_2: "Finalizando el envío de la configuración.",
  SEND_CONFIG_DONE: "Configuración enviada.",
  START_MESSAGE_SUCCESS: "El monitor se iniciará en 15 segundos.",
  START_MESSAGE_FAILURE: "Ocurrió un error al iniciar el monitor.",
  STOP_MESSAGE_SUCCESS: "El monitor se detendrá en 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocurrió un error al detener el monitor.",
  WAITING: "Espere un momento",
  CLEAN_LOG_SUCCESS: "El log se limpió correctamente.",
  CLEAN_LOG_FAILURE: "Ocurrió un error al limpiar el log.",

  CHANGE_USERNAME_SUCCESS: "El nombre de usuario se cambió correctamente. Inicie sesión nuevamente.",
  CHANGE_USERNAME_FAILURE: "Ocurrió un error al cambiar el nombre de usuario: ",
  USERNAME_TOO_SHORT: "El nombre de usuario debe contener al menos un carácter.",
  PASSWORD_MISSMATCH: "Las contraseñas ingresadas no coinciden",
  CHANGE_PASSWORD_SUCCESS: "La contraseña se cambió correctamente. Inicie sesión nuevamente.",
  CHANGE_PASSWORD_FAILURE: "Ocurrió un error al cambiar la contraseña: ",

  VERIFY_THE_FOLLOWING_INFO: "Verifique la siguiente información:",
  INVALID_IP: "\n- La IP ingresada no es válida",
  INVALID_SUBMASK: "\n- La mascarilla de subred ingresada no es válida",
  INVALID_GATEWAY: "\n- La puerta de enlace ingresada no es válida",
  LOOPBACK_IP: "\n- La IP de loopback (127.0.0.1) no se puede utilizar como IP del monitor",
  LOOPBACK_IP_NTP: "\n- La IP de loopback (127.0.0.1) no se puede utilizar como IP del servidor NTP",
  TAG_TOO_LONG: "\n- La etiqueta no puede superar los 30 caracteres",
  SELECT_TIMEZONE: "\n- Debe seleccionar una zona horaria para configurar el servidor NTP",
  SAME_SUBNET_IP_1: "\n- La dirección IP de la interfaz office no puede estar en la misma subred que la interfaz ETHERNET.",
  SAME_SUBNET_IP_2: "\n- La dirección IP de la interfaz ETHERNET no puede estar en la misma subred que la interfaz office.",
  SUBNET_OVERLAP_OFFICE: "\n- TS Monitor EtherNet/IP detectó una superposición de direcciones entre la subred de la interfaz ETHERNET y la subred de la interfaz office. Por este motivo, no se puede configurar la interfaz office con la dirección IP y la mascarilla elegidas.",
  SUBNET_OVERLAP_ETHERNET: "\n- TS Monitor EtherNet/IP detectó una superposición de direcciones entre la subred de la interfaz ETHERNET y la subred de la interfaz office. Por este motivo, no se puede configurar la interfaz ETHERNET con la dirección IP y la mascarilla elegidas.",
  SUBNET_OVERLAP_WLAN: "\n- TS Monitor EtherNet/IP detectó una superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no se puede configurar la WLAN con la dirección IP y la mascarilla elegidas.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Monitor EtherNet/IP detectó una superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no se puede configurar la interfaz ETHERNET con la dirección IP y la mascarilla elegidas.",
  ZERO_IP_MSG: "\n- La IP 0.0.0.0 no se puede utilizar como IP del monitor",
  ZERO_IP_MASK_MSG: "\n- La IP 0.0.0.0 no se puede utilizar como mascarilla de red",
  BROADCAST_IP_MSG: "\n- La IP de broadcast de la red no se puede utilizar como IP del monitor",
  NETWORK_IP_MSG: "\n- La IP de la red no se puede utilizar como IP del monitor",
  BROADCAST_GATEWAY_MSG: "\n- La IP de broadcast de la red no se puede utilizar como IP de la puerta de enlace",
  NETWORK_GATEWAY_MSG: "\n- La IP de la red no se puede utilizar como IP de la puerta de enlace",
 
  GENERATING_REPORT_WAITING: "Generando informe, por favor espere",

  ALTER_USERNAME: "CAMBIAR NOMBRE DE USUARIO",
  ALTER_PASSWORD: "CAMBIAR CONTRASEÑA",

  SELECT_FILE: "Seleccione un archivo para enviar",
  SELECT_AT_LEAST_ONE_FILE: "Seleccione al menos un archivo para enviar",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Seleccione al menos un archivo para eliminar",

  DO_NOT_CLOSE_THIS_TAB: "Mantenga esta pestaña abierta para seguir la actualización.",
  UPDATING_MONITOR_FILES: "Actualizando archivos en el monitor. Espere, por favor.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Archivos actualizados; preparando el reinicio del monitor.",
  RESTARTING_MONITOR_WAIT: "Reiniciando el monitor. Espere unos minutos.",
  MONITOR_RESTART_SUCCESS: "El monitor se reinició correctamente.",
  MONITOR_RESTART_FAILURE: "Ocurrió un error al reiniciar el monitor.",
  UPDATE_SUCCESS: "¡La actualización se realizó correctamente!",
  UPDATE_ERROR_STRING: "Ocurrió el siguiente error al actualizar el monitor: ",

  // ------------------------------- NTP UPDATE STATUS ----------------------------

  NTP_INFO_TURNED_OFF_SUCCESS: "El servidor NTP se apagó correctamente.",
  NTP_INFO_TURNED_OFF_FAILURE: "Ocurrió un error al apagar el servidor NTP.",
  TURN_OFF_DATE: "\nHora de apagado: ",
  NTP_INFO_FAILURE: "No se pudo sincronizar con el servidor. Si el error persiste, póngase en contacto con el administrador del servidor NTP.",
  SEND_NTP_CONFIG_WAITING: "Enviando la configuración del servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configuración del servidor NTP enviada.",

  PROCESSING_NTP_INIT: "Iniciando el procesamiento de la información del servidor NTP.",
  PROCESSING_NTP_INFO: "Procesando la información del servidor NTP.",
  PROCESSED_NTP_INFO: "Información del servidor NTP procesada.",
  PROCESSING_NTP_ERROR: "Ocurrió un error al enviar la información al servidor NTP. Verifique que la dirección IP del servidor sea correcta. Si lo es, compruebe también que el servicio NTP esté activado e inténtelo nuevamente.",

  ITS_NECESSARY_TO_DISABLE_THE_MONITORING_FIRST: "Debe desactivar el monitoreo antes de configurar el escaneo.",
  MONITORING_QUESTION_ICON_INFO: "Activa o desactiva el envío y la captura activos de mensajes. Cuando está desactivado, el monitor no envía mensajes ni obtiene datos.",
  DEVICE_SEARCH_QUESTION_ICON_INFO: "Selecciona la búsqueda continua (constante) o única para reducir el envío de mensajes. En el modo de búsqueda única, no se encontrarán los nuevos dispositivos que aparezcan en la red.",
  GSDML_QUESTION_ICON_INFO: "La carga de archivos GSDML en TS Monitor amplía considerablemente las capacidades de diagnóstico de los activos, permitiendo interpretar información específica del fabricante que solo puede mostrarse cuando estos archivos están cargados en el monitor.",


  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique al menos uno de los campos para actualizar la configuración de la interfaz.",
  TAG_WAS_CHANGED_SUCCESSFULLY: "La etiqueta del monitor se modificó correctamente.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRecuerde actualizar la dirección en el navegador a: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "¡La configuración de la interfaz se actualizó correctamente!",

  CONTINUOUS: "Continua",
  UNIQUE: "Única",

  ALTER_MONITOR_CONFIG: "¿Está seguro de que desea cambiar la configuración del monitor?",
  RESTART_SYSTEM: " Reiniciar sistema",
  CONFIRM_RESTART_SYSTEM: "¿Está seguro de que desea reiniciar el sistema?",
  RESTART_SYSTEM_FAILURE: "Ocurrió un error al intentar reiniciar el sistema.",
  RESTART_SYSTEM_SUCCESS: "La solicitud de reinicio se envió correctamente. Espere aproximadamente 3 minutos para que el sistema se reinicie por completo.",

  PING_LIMIT: "Límite de ping",
  ALTER_PING_LIMIT_SUCCESS: "El límite de ping fue modificado con éxito.",
  ALTER_PING_LIMIT_ERROR: "Ocurrió un error al modificar el límite de ping.",

  PING_LIMIT_POPUP_1: "El límite de ping es el valor de ping promedio por encima del cual se considera que existe un problema con el dispositivo.",
  PING_LIMIT_POPUP_2: "Cada vez que un dispositivo supere este valor, se registrará un evento en TS Expert.",
  PING_LIMIT_POPUP_3: "La unidad de medida del ping es milisegundos (ms).",
  PING_LIMIT_POPUP_4: "El valor mínimo permitido para el límite de ping es 0 ms.",
  PING_LIMIT_POPUP_5: "El valor máximo permitido para el límite de ping es 10.000 ms (10 segundos).",

  PING_LIMIT_OUT_OF_BOUNDS: "El límite de ping debe estar entre 0 y 10.000 ms (10 segundos).",

  RATE: "Tasa",
  PACKET_LOSS_RATE: "Tasa límite de pings perdidos",
  PACKET_LOSS_POPUP: "La tasa límite de pings perdidos determina, para todos los dispositivos, a partir de qué porcentaje de pings perdidos TS Expert registrará un evento.",

  ALTER_PACKET_LOSS_RATE_LIMIT_SUCCESS: "La tasa límite de pings perdidos fue modificada con éxito.",
  ALTER_PACKET_LOSS_RATE_LIMIT_ERROR: "Ocurrió un error al modificar la tasa límite de pings perdidos.",
  PACKET_LOSS_RATE_LIMIT_OUT_OF_BOUNDS: "La tasa límite de pings perdidos debe estar entre 0 y 100 (0-100%).",

  MEDIA_COUNTERS_INCREMENT: "Incremento de Media Counters",
  INTERFACE_COUNTERS_INCREMENT: "Incremento de Interface Counters",
  CLEAR: "Limpiar",

  RESET_MEDIA_COUNTERS_INCREMENT_SUCCESS: "Los incrementos de Media Counters fueron limpiados (puestos en cero) con éxito.",
  RESET_MEDIA_COUNTERS_INCREMENT_FAILURE: "Ocurrió un error al poner en cero los incrementos de Media Counters.",

  RESET_INTERFACE_COUNTERS_INCREMENT_SUCCESS: "Los incrementos de Interface Counters fueron limpiados (puestos en cero) con éxito.",
  RESET_INTERFACE_COUNTERS_INCREMENT_FAILURE: "Ocurrió un error al poner en cero los incrementos de Interface Counters.",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuración de la interfaz Ethernet.",
  ETHERNET_POPUP_2: "Se utiliza para supervisión y acceso web a los datos del monitor.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuración de la interfaz inalámbrica, cuando hay un adaptador disponible.",
  WLAN_POPUP_2: "Se utiliza para supervisión y acceso web a los datos del monitor.",

  SETUP: "Configurar",

  SWEEP: "Escaneo",
  SWEEP_POPUP_MSG: " Permite configurar un escaneo personalizado para hasta 5 subredes.",

  TAG_CONFIG: "Etiqueta de red",
  TAG: "Tag",
  TEST_NETWORK: "Red de prueba",
  TAG_CHANGE_FAILURE: "Ocurrió un error al modificar la etiqueta del monitor.",
  REASON_DP: "Motivo: ",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Encender servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "¿Está seguro de que desea encender el servidor NTP? El monitor deberá reiniciarse.",

  NTP_INFO_TURNED_ON_SUCCESS: "El servidor NTP se encendió correctamente.",
  NTP_INFO_TURNED_ON_FAILURE: "Ocurrió un error al encender el servidor NTP.",
  TURN_ON_DATE: "\nLa hora del servidor se actualizó a: ",
  INTERFACE_CONFIG: "Configuración de interfaz",
  INTERFACE_ETHERNET_CONFIG: "Configuración de interfaz ETHERNET",
  // ---------------------------- WLAN Config ----------------------------
  ALTER_MONITOR_WLAN_CONFIG: "¿Está seguro de que desea cambiar la configuración WLAN del monitor?",
  ALTER_OFFICE_INTERFACE_CONFIG_HEADER: "Configurar interfaz office",
  ALTER_OFFICE_INTERFACE_CONFIG: "¿Está seguro de que desea cambiar la configuración de la interfaz office?",
  ALTER_OFFICE_INTERFACE_CONFIG_2: "Al utilizar el modo DHCP, asegúrese de que la interfaz office no esté configurada en la misma subred que la interfaz ETHERNET; de lo contrario, TS Monitor EtherNet/IP podría comportarse de forma inesperada.",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica el estado del adaptador WLAN del monitor.",
  WLAN_STATUS_POPUP_2: "No se puede cambiar la configuración WLAN si el adaptador está apagado.",

  CONNECTION_STATUS_POPUP_1: "Indica si el monitor está conectado a la red WLAN configurada.",
  CONNECTION_STATUS_POPUP_1_1: "Indica si el monitor está conectado a la red Ethernet configurada.",
  
  WLAN_CONFIG_POPUP_1: "No se puede cambiar la configuración mientras el adaptador WLAN esté apagado.",
  WLAN_CONFIG_POPUP_2: "Se recomienda encarecidamente cambiar la configuración WLAN únicamente al acceder al monitor a través de la red cableada.",
  WLAN_CONFIG_POPUP_3: "Al cambiar la IP o la mascarilla, que los campos aparezcan en blanco después de la actualización es un fuerte indicio de que:",
  WLAN_CONFIG_POPUP_4: "Ya existe otro dispositivo en la red con la misma IP;",
  WLAN_CONFIG_POPUP_5: "La mascarilla de red es demasiado restrictiva y no incluye la IP especificada.",

  ETHERNET_CONFIG_POPUP: "Campo de configuración de la interfaz Ethernet conectada a la red industrial y utilizada por TS Monitor para la captura de datos.",
  WLAN_CONFIG_POPUP: "Campo de configuración de la interfaz inalámbrica, cuando hay un adaptador disponible, utilizada para supervisión y acceso web a los datos de TS Monitor. Esta red está aislada de la red Ethernet/Industrial.",
  OFFICE_CONFIG_POPUP: "Campo de configuración de la interfaz Ethernet utilizada para supervisión y acceso web a los datos de TS Monitor. Esta red está aislada de la red Ethernet/Industrial.",
  BLACKLIST_CONFIG_POPUP: "Permite excluir algunos servicios de recopilación de datos de TS Monitor.",
  TS_EXPERT_CONFIG_POPUP: "Permite habilitar o deshabilitar las no conformidades que informa la herramienta.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Monitor EtherNet/IP no pudo encontrar el adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique si el adaptador está desconectado o tiene mal contacto;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Si el adaptador no está desconectado ni tiene mal contacto, intente reemplazarlo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Si ninguna de las opciones anteriores resuelve el problema, comuníquese con Toledo e Souza.",

  HOSTNAME_POPUP_1: "Un nombre de host debe tener entre 2 y 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Además, solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar con letras o números.",

  INVALID_HOSTNAME_1: "El nombre de host debe tener entre 2 y 64 caracteres.",
  INVALID_HOSTNAME_2: "El nombre de host solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar con letras o números.",

  HOSTNAME_CONFIG_SUCCESS: "El nombre de host se configuró correctamente.",
  HOSTNAME_CONFIG_ERROR: "Ocurrió un error al configurar el nombre de host",
  MODE: "Modo",
  HIDDEN_SSID: "SSID oculto",
  OPTIONAL: " (Opcional)",
  FIXED_IP: "IP fija",

  TURNING_WLAN_OFF_WAITING: "Apagando el adaptador WLAN. Espere, por favor.",
  TURNING_WLAN_ON_WAITING: "Encendiendo el adaptador WLAN. Espere, por favor.",

  INVALID_DNS: "\n- El DNS ingresado no es válido",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique al menos uno de los campos para actualizar la configuración WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "¡La configuración WLAN se actualizó correctamente!",
  UPDATE_OFFICE_INTERFACE_CONFIG_SUCCESS: "¡La configuración de la interfaz office se actualizó correctamente!",
  UPDATE_WLAN_CONFIG_ERROR: "No se pudo conectar a la red WLAN. Si el problema persiste, intente reiniciar el monitor o el router WLAN.",
  UPDATE_OFFICE_INTERFACE_CONFIG_ERROR: "Error al configurar la interfaz Office. Si el problema persiste, intente reiniciar el monitor o el router.",

  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configuración WLAN",
  CONNECTION_STATUS: "Estado de la conexión",

  WLAN_ADAPTER_ON: "Encendido",
  WLAN_ADAPTER_OFF: "Apagado",
  NETWORK_NAME_1: "Nombre de la red",
  SEND_WLAN_CONFIG_WAITING: "Enviando la configuración. Espere, por favor; esto puede tardar aproximadamente un minuto.",
  LOADING_WAITING: "Cargando información. Espere, por favor.",
  WLAN_INFO: "Información WLAN",
  ETHERNET_OFFICE_INFO: "Información ETHERNET de Office",
  IP_PLACEHODLER: "192.168.2.220",
  SSID: "SSID",
  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH: "Intensidad de señal",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY: "Frecuencia",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL: "Canal",
  QUALITY: "Calidad",
  QUALITY_PLACEHOLDER: "Calidad",
  SUBMASK: "Mascarilla",
  GATEWAY: "Gateway",
  MASK: "Mascarilla",
  ZERO_TRAFFIC: "0,00 Kbps",
  DNS: "DNS",

  ETHERNET_INTERFACE: "Interfaz ETHERNET",

  OFFICE_INTERFACE: "Interfaz OFFICE",

  // ---------------------------- Sweep Page ----------------------------
  PERSONALIZED_SWEEP: "Escaneo personalizado",

  SWEEP_ON: "Activado",
  SWEEP_OFF: "Desactivado",
  BANDS: "Rangos",

  FIRST_BAND: "1.er rango",
  SECOND_BAND: "2.º rango",
  THIRD_BAND: "3.er rango",
  FOURTH_BAND: "4.º rango",
  FIFTH_BAND: "5.º rango",

  BEGINNING: "Inicio",
  END: "Fin",

  ALERT_MESSAGE_PLACEHOLDER: "Los campos de los siguientes rangos presentan problemas: ",

  FIRST_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del 1.er rango no es válida",
  FIRST_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección inicial del 1.er rango es mayor o igual que la dirección final",
  FIRST_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 1.er rango tiene campos sin completar",

  SECOND_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del 2.º rango no es válida",
  SECOND_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección inicial del 2.º rango es mayor o igual que la dirección final",
  SECOND_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 2.º rango tiene campos sin completar",

  THIRD_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del 3.er rango no es válida",
  THIRD_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección inicial del 3.er rango es mayor o igual que la dirección final",
  THIRD_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 3.er rango tiene campos sin completar",

  FOURTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del 4.º rango no es válida",
  FOURTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección inicial del 4.º rango es mayor o igual que la dirección final",
  FOURTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 4.º rango tiene campos sin completar",

  FIFTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - La dirección del 5.º rango no es válida",
  FIFTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - La dirección inicial del 5.º rango es mayor o igual que la dirección final",
  FIFTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - El 5.º rango tiene campos sin completar",

  SWEEP_DATA_SENT_SUCCESSFULLY: "La configuración del escaneo se guardó correctamente.",
  SWEEP_DATA_SENT_ERROR: "Ocurrió un error al guardar la configuración del escaneo.",
  SPECIFY_AT_LEAST_ONE_SUBNETWORK: "Es necesario especificar al menos una subred para guardar el escaneo personalizado.",

  UNABLE_TO_SAVE_CUSTOM_SWEEP: "No se puede guardar el escaneo personalizado porque:",
  _THE: "- El rango ",
  BAND_HAS_IPS_NOT_IN_SUBNETWORK: " contiene direcciones IP que no pertenecen a la subred del monitor",
  SENDING_DATA: "Enviando datos",

  // ---------------------------- PDF Report ----------------------------

  CONFORM_STRING: "Conforme",
  CONFORM_W_RESTRICTION_STRING: "Conforme con restricciones",
  NON_CONFORM_STRING: "No conforme",

  GENERATING_REPORT_SUCCESS: "Informe generado con éxito. Para guardarlo, haga clic en guardar informe abajo.",

  CONFORMITY: "Conformidad",
  DROPDOWN_PLACEHOLDER: "Elija una opción",
  GENERATE_REPORT: "Generar informe",
  PING_GRAPHS: "Gráficos de ping",
  INCLUDE_IN_REPORT: "Incluir en el informe",
  CLIENT_INFO: "Información del cliente",
  EXECUTING_COMPANY_INFO: "Información de la empresa ejecutora",
  PROJECT_NAME_LABEL: "Nombre del proyecto",
  NETWORK_NAME_LABEL: "Nombre de la red",
  LOCATION_LABEL: "Ubicación",
  COMPANY_NAME_LABEL: "Nombre de la empresa",
  ACCOUNTABLE_NAME_LABEL: "Nombre del responsable",
  ADDRESS_LABEL: "Dirección",
  CITY_LABEL: "Ciudad",
  PHONE_LABEL: "Teléfono",
  EMAIL_LABEL: "Correo electrónico",
  CLIENT_LOGO_LABEL: "Logo del cliente",
  EXECUTING_COMPANY_LOGO_LABEL: "Logo de la empresa ejecutora",
  ANNOTATIONS: "Anotaciones",
  CONCLUSION: "Conclusión",

  HEADER_TEXT: "Informe de datos - TS Monitor EtherNet/IP",
  REPORT_EXPORT_NAME: "Informe TS Monitor EtherNet/IP",

  GENERAL_REPORT: "Informe general – TS Monitor EtherNet/IP",
  DATA_REPORT: "Informe de datos – TS Monitor EtherNet/IP",

  PROJECT_NAME: "- Nombre del proyecto:",
  NETWORK_NAME: "- Nombre de la red:",
  LOCATION: "- Ubicación:",
  COMPANY_NAME: "- Nombre de la empresa:",
  ACCOUNTABLE_NAME: "- Nombre del responsable:",
  COMPANY_ADDRESS: "- Dirección:",
  COMPANY_CITY: "- Ciudad:",
  COMPANY_TEL: "- Teléfono:",

  EXECUTING_COMPANY_NAME: "- Nombre de la empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nombre del responsable:",
  EXECUTING_TEL: "- Teléfono:",
  EXECUTING_EMAIL: "- Email:",

  MONITORING_INFO: "Información de monitoreo",
  NETWORK_TAG_DP: "- Tag de la red: ",
  NETWORK_NAME_DP: "- Nombre de la red: ",
  MONITOR_IP: "- IP del monitor: ",
  MONITOR_SUBMASK_DP: "- Mascarilla del monitor: ",
  GATEWAY_DP: "- Gateway: ",
  DNS_DP: "- DNS: ",
  MODO_DP: "- Modo de configuración: ",
  MONITOR_VERSION_DP: "- Versión del monitor: ",
  MONITOR_TIME_ON_DP: "- Tiempo encendido: ",
  MEASUREMENT_INTERVAL_DP: "- Período de medición: ",
  REPORT_GENERATION: "- Informe generado en: ",
  NUM_OF_DEVICES_DP: "- Cantidad de dispositivos encontrados: ",
  NETWORK_AVAILABILITY_DP_2: "- Disponibilidad de la red: ",
  ETHERNET_INFO: "Información ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Mascarilla: ",

  SUMMARY: "Resumen",
  OVERVIEW: "Vista general",
  LIVE_LIST: "Live List",
  INVENTORY: "Inventario",
  PORTS: "Puertos",
  NETWORK: "Red",
  TOPOLOGY: "Topología",
  MEDIA_COUNTERS: "Media Counters",
  INTERFACE_COUNTERS: "Interface Counters",
  LOG: "Log",
  PING_GRAPH: "Gráfico de ping",
  DISCLAIMER: "Aviso legal",

  OVERVIEW_DOTS: ".....................................................................................................................................",
  LIVE_LIST_DOTS: ".........................................................................................................................................",
  INVENTORY_DOTS: "......................................................................................................................................",
  PORTS_DOTS: ".........................................................................................................................................",
  NETWORK_DOTS: "................................................................................................................................................",
  TOPOLOGY_DOTS: ".....................................................................................................................................",
  MEDIA_COUNTERS_DOTS: "............................................................................................................................",
  INTERFACE_COUNTERS_DOTS: ".......................................................................................................................",
  LOG_DOTS: "................................................................................................................................................",
  PING_GRAPH_DOTS: ".............................................................................................................................",
  DISCLAIMER_DOTS: "....................................................................................................................................",
  DISCLAIMER_DOTS_2: "....................................................................................................................................",

  OVERVIEW_PAGE_TITLE: "1. - Vista general",
  LIVE_LIST_PAGE_TITLE: "1. - Live List",
  INVENTORY_PAGE_TITLE: "2. - Inventario",
  PORTS_PAGE_TITLE: "3. - Puertos",
  NETWORK_PAGE_TITLE: "4. - Red",
  TOPOLOGY_PAGE_TITLE: "5. - Topología",
  MEDIA_COUNTERS_PAGE_TITLE: "5. - Media Counters",
  INTERFACE_COUNTERS_PAGE_TITLE: "6. - Interface Counters",
  LOG_PAGE_TITLE: "7. - Log",
  PING_GRAPH_PAGE_TITLE: "8. - Gráfico de Ping",

  TS_MONITOR_VER_DP: "TS Monitor EtherNet/IP - Versión ",
  NETWORK_STATUS_DP: "Estado de la red: ",
  DEVICE_DATA: "Datos de los dispositivos",

  CONTROLLERS_DP: "Controladores: ",
  DEVICES_DP: "Dispositivos: ",
  SUPERVISORS_DP: "Supervisores: ",
  OTHER_DEVICES_DP: "Otros dispositivos: ",
  FAULTS_DP: "Fallas: ",
  ALARMS_DP: "Alarmas: ",
  IN_TRAFFIC_DP: "Tráfico ethernet de entrada: ",
  OUT_TRAFFIC_DP: "Tráfico ethernet de salida: ",

  MAC: "MAC",
  MACS: "MACs",
  IP: "IP",
  SNMP: "SNMP",
  NEIGHBOUR_PORT_1: "Puerto",
  NEIGHBOUR_PORT_2: "vecino",
  NEIGHBOUR_IP: "IP vecino",

  DUPLICATE_IP_STRING: "IP duplicada",

  END_OF_REPORT: "Fin del informe",
  DISCLAIMER_TEXT: "Los datos y valores presentados en este informe son meramente auxiliares para el especialista en EtherNet/IP, de modo que cualquier indicación de corrección debe ser realizada por el usuario. Por esta razón, se recomienda el acompañamiento de un ingeniero certificado en EtherNet/IP o del técnico responsable del análisis para validar la información proporcionada por el producto. Por lo tanto, Toledo & Souza se exime de cualquier responsabilidad, pérdida o daño, directo o indirecto, causado por las interpretaciones del software, no ofreciendo ninguna garantía respecto a la integridad, calidad o adecuación de la información proporcionada, ya que depende del análisis técnico de un profesional capacitado; en ausencia de este, el usuario asumirá el riesgo de que el contenido pueda ser impreciso, incompleto o que no satisfaga sus necesidades y requisitos.",

  PROTOCOL: "Protocolo",
  CONFIG_METHOD: "Método de configuración",
  CURRENT_PING: "Ping actual",
  MEDIUM_PING: "Ping promedio",
  LOST_PACKET_PERC: "Pings perdidos (%)",

  PRODUCT_NAME: "Nombre del producto",
  PRODUCT_NAMES: "Nombre de los productos",
  VENDOR_ID: "Vendor ID",
  REVISION: "Revisión",
  PRODUCT_CODE: "Product Code",
  SERIAL_NUMBER: "Serial Number",
  DEVICE_TYPE: "Tipo de dispositivo",
  DEVICE_TYPE_1: "Tipo de",
  DEVICE_TYPE_2: "dispositivo",

  PRODUCT_NAME_N: "Nombre\ndel\nproducto",
  INTERFACE_TYPE: "Tipo\nde\ninterfaz",
  DUPLEX_MODE: "Modo\nDuplex",
  INTERFACE_SPEED: "Velocidad\nde la\ninterfaz",
  NEGOTIATION_STATUS: "Estado\nde\nnegociación",
  HARDWARE_FAILURE: "Falla\nde\nhardware",
  INTERFACE_STATE: "Estado\nde la\ninterfaz",
  LINK_STATUS: "Estado\ndel\nenlace",

  ACTIVE: "Activo",
  INACTIVE: "Inactivo",

  NETWORK_TOPOLOGY: "Topología de la red",
  NETWORK_STATUS: "Estado de la red",
  ACD_CAPABLE: "Compatible\ncon ACD",
  ACD_STATUS: "ACD\nStatus",
  ANNOUNCE_BASED: "Nodo de anillo\nbasado en anuncios",
  BEACON_BASED: "Nodo de anillo\nbasado en balizas",
  FLUSH_TABLE_CAPABLE: "Compatible con trama\nde vaciado de tabla",
  REDUNDANT_GATEWAY_CAPABLE: "Compatible con gateway\nredundante",
  SUPERVISOR_CAPABLE: "Compatible con\nsupervisor",

  ALIGNMENET_ERRORS: "Alignment\nErrors",
  CARRIER_SENSE_ERRORS: "Carrier Sense Errors",
  FCS_ERRORS: "FCS\nErrors",
  SINGLE_COLLISIONS: "Single\nCollisions",
  MULTIPLE_COLLISIONS: "Multiple\nCollisions",
  LATE_COLLISIONS: "Late\nCollisions",
  EXCESSIVE_COLLISIONS: "Excessive Collisions",
  SQE_TEST_ERRORS: "SQE\nTest\nErrors",
  DEFERRED_TRANSMISSION: "Deferred Transmission",
  FRAME_TOO_LONG: "Frame\nToo\nLong",
  MAC_TRANSMIT_ERRORS: "MAC\nTransmit\nErrors",
  MAC_RECEIVE_ERRORS: "MAC\nReceive\nErrors",

  TRAFFIC_KBPS: "Tráfico (Kbps)",
  IN_OCTETS: "In\nOctets",
  IN_UCAST_PKTS: "In\nUcast\nPackets",
  IN_NUCAST_PKTS: "In\nNUcast\nPackets",
  IN_DISCARDS: "In\nDiscards",
  IN_ERRORS: "In\nErrors",
  IN_UNKNOWN_PROTOS: "In\nUnknown\nProtos",
  OUT_OCTETS: "Out\nOctets",
  OUT_UCAST_PKTS: "Out\nUcast\nPackets",
  OUT_NUCAST_PKTS: "Out\nNUcast\nPackets",
  OUT_DISCARDS: "Out\nDiscards",
  OUT_ERRORS: "Out\nErrors",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Anterior a la última inicialización",
  REMOVE_DEVICE_SUCCESS: "El dispositivo será eliminado en hasta 30 segundos.",
  REMOVE_DEVICE_FAILURE: "Ocurrió un error al eliminar el dispositivo: ",
  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "Con alarma",
  WITH_FAILURE_STRING: "Con falla",
  UNKNOWN: "Desconocido",
  NO_EVENT: "Ningún evento",
  LOG_WAITING: "Cargando datos del log",
  GO_TO_LOG_OR_REMOVE_POSITIONING: "Eliminar device",
  ASK_DELETE_OR_LOG_1: "¿Desea eliminar de la lista este device con IP duplicada?",
  ASK_DELETE_OR_LOG_2: "¿Desea eliminar de la lista este device con posible pérdida de IP?",
  DELETE: "Eliminar",
  GO_TO_LOG: " Ir al log",
  MEDIA_COUNTERS_PLACEHOLDER: "Filtrar por IP",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC o protocolo",
  INVENTORY_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC o nombre del producto",
  PORTS_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC o nombre del producto",
  NETWORK_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP o topología de la red",

  TOPOLOGY_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP o MAC",
  TRAFFIC_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, nombre o modelo",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar IP, MAC, nombre del producto o tipo",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Buscar dispositivo por IP",
  FAULTS: "Fallos",
  STATISTICS: "Estadísticas",
  BILLIONS_OF: "Miles de millones de",
  ONE_MILLION_OF: "Millón",
  ONE_BILLION_OF: "Mil millones",
  MILLIONS_OF: "Millones de",
  THOUSAND: "Mil",
  THOUSAND_NO_CAPITAL: " mil",
  MILLION_NO_CAPITAL: " millón",
  MILLIONS_NO_CAPITAL: " millones",
  BILLION_NO_CAPITAL: " mil millones",
  BILLIONS_NO_CAPITAL: " miles de millones",
  LAST_EVENT: "Último evento: ",
  UP_TIME: "Tiempo encendido:",
  MONITORING: "Monitoreo: ",
  TURNED_OFF: "Desactivado ",
  TURNED_ON: "Activado ",
  MONITORING_ON_TOOLTIP: "El servicio de monitoreo está activado.",
  MONITORING_OFF_TOOLTIP: "El servicio de monitoreo está desactivado. Para activarlo, acceda a la ventana MONITOREO en la pestaña Configuraciones.",
  MONITORING_GETTING_CONNECTION: "Estableciendo conexión.",

  ALARMS_QUESTION_INFO: "Indica la cantidad de alarmas reportadas por los dispositivos. Las alarmas indican condiciones anormales del dispositivo, como cortocircuitos, problemas de alimentación, módulos faltantes, entre otros.",
  FAULTS_QUESTION_INFO: "Indica cuántas veces un dispositivo EtherNet/IP no respondió a los mensajes enviados por TS Monitor.",

  TYPE: "Tipo",
  DEVICE: "Dispositivo",

  // ---------------------------- GRAPH COLORS ----------------------------

  // ---------------------------- EXPERT ERROR TYPES ----------------------------





  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de acciones - TS Expert - EtherNet/IP",

  TS_EXPERT_POPUP_1: "En esta pestaña se presentan las informaciones de TS Expert.",
  TS_EXPERT_POPUP_2: "Esta herramienta es un sistema experto desarrollado para optimizar y acelerar el análisis de las principales divergencias detectadas por TS Monitor EtherNet/IP en redes EtherNet/IP.",
  TS_EXPERT_POPUP_3: "De forma automatizada, mantenimiento, ingeniería y equipos relacionados pueden obtener una lista de acciones con diferentes eventos, sus posibles causas, sugerencias de solución y los dispositivos en los que fueron detectados.",
  TS_EXPERT_POPUP_4: "El uso de TS Expert no excluye la necesidad del análisis humano ni sustituye estas capacidades de crear correlaciones de datos e interpretación.",

  TS_EXPERT: "TS Expert",
  EVENTS_LIST: "Lista de eventos",
  DETECTED_ON: "Detectado en: ",
  INCREMENT_DETECTED_ON: "Incremento más reciente detectado en: ",
  EXPORT_ACTIONS_LIST: "Exportar lista de acciones",
  GENERATING_TS_EXPERT_REPORT_SUCCESS: "Informe generado con éxito. Para guardarlo, haga clic en guardar informe.",

  ACTIONS: "Acciones",

  NO_PROBLEM_DETECTED: "TS Expert no detectó ningún problema en la red.",
  NO_EVENTS_TO_BE_ANALYZED: "No existen eventos para ser analizados.",

  NO_EVENT_SELECTED: "Ningún evento seleccionado",
  CHOOSE_AN_EVENT: "Elija un evento para visualizar las acciones sugeridas.",

  DETAILING: "Detalle",

  CHECKED: "Verificado",
  BATCH_CHECK: "Verificar todos",

  PROBLEM_CHECKED: "El evento fue verificado con éxito",
  PROBLEM_CHECK_ERROR: "Ocurrió un error al verificar el evento.",

  QUANTITY_DP: "Cantidad: ",

  DEVICE_HAS_MEDIA_COUNTERS_PROBLEMS: "El dispositivo posee incrementos de media counters en los siguientes puertos:",
  DEVICE_HAS_INTERFACE_COUNTERS_PROBLEMS: "El dispositivo posee incrementos de interface counters en los siguientes puertos:",

  PORT_IS_STILL_INACTIVE: "El puerto aún está inactivo",
  MARK_PROBLEM_AS_SOLVED: "¿Está seguro de que desea marcar el evento como verificado?",

  LAST_UPDATED: "Actualizado por última vez en: ",
  THIS_COMPUTER_TIME: " (Hora de esta computadora)",

  // ------------------------------ PING LIMIT ------------------------------
  GROUP_PING_LIMIT_HEADER: "Existen dispositivos en la red que excedieron el valor límite de ping.",
  THE_LIMIT_VALUE_IS: "El valor límite es de: ",

  PING_LIMIT_EXCEEDED: "Límite de ping excedido",

  PING_LIMIT_HEADER_1: "El dispositivo con IP ",
  PING_LIMIT_HEADER_2: " excedió el límite de ping.",

  PING_LIMIT_DESCRIPTION_1: "IP: ",
  PING_LIMIT_DESCRIPTION_2: "MAC: ",
  PING_LIMIT_DESCRIPTION_3: "Nombre del producto: ",
  PING_LIMIT_DESCRIPTION_4: "Ping registrado: ",

  PING_LIMIT_SUGGESTION_1: "Cuando un dispositivo exceda el valor límite de ping se sugiere:",
  PING_LIMIT_SUGGESTION_2: "Problemas de tráfico:",
  PING_LIMIT_SUGGESTION_3: "Utilizar la pestaña Interface Counters y revisar las aplicaciones que están utilizando el enlace, verifique si están de acuerdo con la infraestructura disponible;",
  PING_LIMIT_SUGGESTION_4: "Verificar si el ancho de banda disponible satisface la aplicación (uso de switches Fast o Gigabit Ethernet).",

  PING_LIMIT_SUGGESTION_5: "Alto uso de procesamiento de equipos y switches:",
  PING_LIMIT_SUGGESTION_6: "Revisar el consumo de datos de la aplicación;",
  PING_LIMIT_SUGGESTION_7: "Revisar la temperatura de los equipos.",

  PING_LIMIT_SUGGESTION_8: "Retraso en la propagación (longitud excesiva de cables):",
  PING_LIMIT_SUGGESTION_9: "Identificar la longitud del cable, visualmente cuando esté grabada en el cable, o utilizando probadores o certificadores.",

  NO_DEVICE_EXCEEDED_PING_LIMIT: "No existen dispositivos en la red que hayan excedido el límite de ping",

  // ------------------------------ DUPLICATE IP ------------------------------
  GROUP_DUPLICATE_IP_LIST_HEADER: "Existen dispositivos en la red con IP duplicada.",
  GROUP_DUPLICATE_IP_LIST_DESCR: "Por favor, verifique su red.",

  DEVICES_WITH_DUPLICATE_IP: "Dispositivos con IP duplicada",
  DUPLICATE_IP_CARD_DESC: "Los dispositivos abajo están utilizando la dirección IP ",

  DUPLICATE_IP_SUGGESTION_1: "Cuando existan IPs duplicadas en la red se sugiere:",
  DUPLICATE_IP_SUGGESTION_2: "Verificar las direcciones físicas, MAC, para identificar los dispositivos que presentan conflicto de dirección IP y corregir las configuraciones de esta dirección.",
  NO_DEVICES_WITH_DUPLICATE_IPS: "No existen dispositivos en la red con IPs duplicadas",

  // ------------------------------ DHCP ------------------------------
  DHCP_LIST_HEADER: "Existen dispositivos en la red cuyos IPs fueron configurados por DHCP.",
  DHCP_LIST_DESCR: "Idealmente el método de configuración debe ser estático.",

  DHCP_CONFIG_METHOD: "Método de configuración DHCP",

  DHCP_SUGGESTION_1: "Cuando el método de configuración de un dispositivo sea DHCP se sugiere:",
  DHCP_SUGGESTION_2: "Verificar si se está utilizando direccionamiento vía DHCP. Esto no se recomienda para un entorno industrial, ya que la mayoría de las aplicaciones utiliza direcciones IP fijas y la configuración automática puede generar conflictos si no se planifica con precisión. Por esta razón, se sugiere utilizar el método de configuración como IP fija.",

  NO_DEVICES_CONFIGURED_BY_DHCP: "No existen dispositivos en la red configurados por DHCP",

  // ------------------------------ PACKET LOSS ------------------------------
  GROUP_PACKET_LOSS_LIST_HEADER: "Existen dispositivos en la red con % de pings perdidos por encima de la tasa límite.",
  GROUP_PACKET_LOSS_LIST_DESCR: "Por favor, verifique su red.",

  PACKET_LOSS_GREATER_ONE_PERCENT: "% de pings perdidos por encima de la tasa límite",
  PACKET_LOSS_DESCRIPTION: "Pings perdidos (%): ",

  PACKET_LOSS_SUGGESTION_1: "Cuando el % de pings perdidos de un dispositivo esté por encima de la tasa límite se sugiere:",
  PACKET_LOSS_SUGGESTION_2: "Verificar si el dispositivo objetivo está debidamente energizado e instalado;",
  PACKET_LOSS_SUGGESTION_3: "Verificar la presencia de interferencia electromagnética, en caso de que sea intermitente o con comportamiento no lineal;",
  PACKET_LOSS_SUGGESTION_4: "Realizar certificación y prueba de los cables para descartar la hipótesis de problemas en el medio físico;",
  PACKET_LOSS_SUGGESTION_5: "Verificar el tráfico del enlace que conecta los dispositivos;",
  PACKET_LOSS_SUGGESTION_6: "Verificar el uso de memoria y CPU de los dispositivos;",
  PACKET_LOSS_SUGGESTION_7: "Verificar la temperatura de los dispositivos.",
  PACKET_LOSS_SUGGESTION_8: "Los paquetes ping considerados perdidos son aquellos que fueron enviados, pero no regresaron al dispositivo que los envió.",
  OBS: "OBS: ",

  NO_DEVICES_SURPASSED_PING_LOST_LIMIT: "No existen dispositivos en la red cuyo % de pings perdidos haya superado la tasa límite",

  // ------------------------------ INACTIVE PORT ------------------------------
  INACTIVE_PORT_LIST_HEADER: "Existen dispositivos en la red cuyos puertos fueron desactivados.",
  INACTIVE_PORT_LIST_DESCR: "Por favor, verifique su red.",

  INACTIVE_PORT: "Puerto desactivado",
  PORT: "Puerto",

  INACTIVE_PORT_SUGGESTION_1: "Cuando un puerto sea desactivado se sugiere:",
  INACTIVE_PORT_SUGGESTION_2: "Verificar si el dispositivo conectado al extremo del cable está energizado;",
  INACTIVE_PORT_SUGGESTION_3: "Verificar si hubo rotura del cable;",
  INACTIVE_PORT_SUGGESTION_4: "Verificar la configuración del puerto, en caso de que haya sido deshabilitado.",

  NO_DEVICES_WITH_INACTIVE_PORTS: "No existen dispositivos en la red que posean puertos desactivados (estaba activo y pasó a quedar inactivo)",

  // ------------------------------ NOT IN AUTONEGOTIATION ------------------------------
  NOT_IN_AUTONEGOTIATION_LIST_HEADER: "Existen dispositivos en la red cuya autonegociación de alguno de los puertos falló.",
  NOT_IN_AUTONEGOTIATION_LIST_DESCR: "Por favor, verifique su red.",

  AUTONEGOTIATION_FAILED: "La autonegociación falló",

  NOT_IN_AUTONEGOTIATION_SUGGESTION_1: "Cuando la autonegociación de un puerto falle se sugiere:",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_2: "Verificar la condición del cableado (mala terminación de conectores, cables dañados o rotos, cables y conectores de baja calidad o cableado excesivamente largo para la categoría);",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_3: "Verificar la configuración de los puertos en ambos extremos (es posible que alguna tasa de comunicación o modo duplex haya sido fijado y sea incompatible con las configuraciones del puerto del otro extremo);",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_4: "Verificar si los hardwares son incompatibles (diferentes implementaciones del estándar de autonegociación pueden generar incompatibilidad);",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_5: "La autonegociación no se aplica a enlaces de fibra óptica.",

  NO_DEVICES_WITH_AUTONEGOTIATION_FAULT: "No existen dispositivos en la red con puertos cuya autonegociación haya fallado",

  // ------------------------------ NOT IN FULL DUPLEX ------------------------------
  NOT_IN_FULL_DUPLEX_LIST_HEADER: "Existen dispositivos en la red con puertos no configurados en modo Full Duplex.",
  NOT_IN_FULL_DUPLEX_LIST_DESCR: "Por favor, verifique su red.",

  PORT_NOT_IN_FULL_DUPLEX: "Puerto no configurado en modo Full Duplex",

  NOT_IN_FULL_DUPLEX_SUGGESTION_1: "Cuando el modo duplex de un puerto no sea Full Duplex se sugiere:",
  NOT_IN_FULL_DUPLEX_SUGGESTION_2: "Verificar si la configuración de los puertos está en auto o forzada;",
  NOT_IN_FULL_DUPLEX_SUGGESTION_3: "Verificar la integridad del cableado.",
  NOT_IN_FULL_DUPLEX_SUGGESTION_4: "Utilizar Full Duplex permite un mayor uso del ancho de banda total (envío y recepción) y menores tiempos de respuesta.",

  NO_DEVICES_WITHOUT_FULL_DUPLEX: "No existen dispositivos en la red con puertos cuyo modo duplex no sea Full Duplex",

  // ------------------------------ INTERFACE SPEED ------------------------------
  INTERFACE_SPEED_LIST_HEADER: "Existen dispositivos en la red con puertos de velocidad de interfaz < 100 Mbps.",
  INTERFACE_SPEED_LIST_DESCR: "Por favor, verifique su red.",

  INTERFACE_SPEED_LESSER_THAN_100: "Velocidad de la interfaz < 100 Mbps",

  INTERFACE_SPEED_SUGGESTION_1: "Cuando la velocidad de la interfaz de un puerto sea < 100 Mbps:",
  INTERFACE_SPEED_SUGGESTION_2: "Aunque la aplicación no demande un ancho de banda mayor que 10 Mbits, tráficos eventuales de accesos esporádicos o mantenimientos pueden causar pérdida de comunicación.",
  INTERFACE_SPEED_SUGGESTION_3: "Se sugiere utilizar al menos 100 Mbps para enlaces normales y 1 Gbps para anillos de redundancia y enlaces prioritarios o de alta demanda.",

  NO_DEVICES_WITH_SLOW_PORTS: "No existen dispositivos en la red con puertos cuya velocidad de interfaz sea < 100 Mbps",

  // ------------------------------ HARDWARE FAULT ------------------------------
  HARDWARE_FAULT_LIST_HEADER: "Existen dispositivos en la red que presentan falla de hardware local en alguno de sus puertos.",
  HARDWARE_FAULT_LIST_DESCR: "Por favor, verifique su red.",

  PORT_WITH_LOCAL_HARDWARE_FAULT: "Puerto con falla de hardware local",

  HARDWARE_FAULT_SUGGESTION_1: "Cuando un puerto tenga falla de hardware local se sugiere:",
  HARDWARE_FAULT_SUGGESTION_2: "Sustituir o reparar el dispositivo, y cambiar el puerto utilizado.",

  NO_DEVICES_WITH_PORT_HARDWARE_FAULT: "No existen dispositivos en la red con puertos que posean falla de hardware local",

  // ------------------------------ ADDR CONFLICT ------------------------------
  ADDR_CONFLICT_LIST_HEADER: "Existen dispositivos en la red que detectaron conflictos de dirección.",
  ADDR_CONFLICT_LIST_DESCR: "Por favor, verifique su red.",

  ADDR_CONFLICT_DETECTED: "Conflicto de dirección detectado",

  ADDR_CONFLICT_DETECTED_SUGGESTION_1: "Cuando un dispositivo detecte conflicto de dirección se sugiere:",
  ADDR_CONFLICT_DETECTED_SUGGESTION_2: "Verificar la dirección física MAC del otro dispositivo con dirección en conflicto y corregir las configuraciones de dirección lógica IP.",

  NO_DEVICES_WITH_ADDR_CONFLICT_DETECTED: "No existen dispositivos en la red con conflicto de dirección",

  // ------------------------------ MEDIA COUNTERS ------------------------------
  MEDIA_COUNTERS_LIST_HEADER: "Existen dispositivos con incremento de media counters.",

  MEDIA_COUNTERS_HEADER: "Incremento de Media Counters",
  ALIGNMENT_ERROR_HEADER: "Incremento de Alignment Errors",
  CARRIER_SENSE_HEADER: "Incremento de Carrier Sense Errors",
  FCS_ERROR_HEADER: "Incremento de FCS Errors",
  SINGLE_COLLISION_HEADER: "Incremento de Single Collisions",
  MULTIPLE_COLLISIONS_HEADER: "Incremento de Multiple Collisions",
  LATE_COLLISIONS_HEADER: "Incremento de Late Collisions",
  EXCESSIVE_COLLISIONS_HEADER: "Incremento de Excessive Collisions",
  SQE_TEST_HEADER: "Incremento de SQE Test Errors",
  DEFERRED_TRANSMISSION_HEADER: "Incremento de Deferred Transmissions",
  FRAME_TOO_LONG_HEADER: "Incremento de Frame Too Long",
  MAC_TRANSMIT_HEADER: "Incremento de MAC Transmit Errors",
  MAC_RECEIVE_HEADER: "Incremento de MAC Receive Errors",
  MEDIA_COUNTERS_NOT_SUPPORTED: "El dispositivo no soporta acceso a los media counters",
  MEDIA_COUNTERS_NOT_ANSWERED_YET: "El dispositivo aún no respondió",

  MEDIA_COUNTERS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Media Counters se sugiere:",
  MEDIA_COUNTERS_SUGGESTION_2: "Navegar hasta la pestaña Media Counters y hacer clic en el botón presente en la esquina superior derecha de la pantalla (según la imagen abajo) para descargar el PDF de sugerencias de acciones.",
  MEDIA_COUNTERS_SUGGESTION_3: "En el documento se presentan las posibles causas para el incremento de cada uno de los tipos de Media Counters.",

  MEDIA_COUNTERS_SUGGESTION_4: "Hacer clic en el botón abajo para descargar el PDF de sugerencias de acciones. En el documento se presentan las posibles causas para el incremento de cada uno de los tipos de Media Counters.",

  DEVS_WITH_MEDIA_COUNTERS_EXPLANATION_1: "En esta lista se muestran solo los dispositivos y respectivos puertos que poseen incremento en al menos un tipo de contador de media counters.",
  DEVS_WITH_MEDIA_COUNTERS_EXPLANATION_2: "Los contadores que tengan incremento estarán destacados con el color naranja.",

  NO_DEVICES_WITH_MEDIA_COUNTERS_INCREMENT: "No existen dispositivos en la red con incremento de media counters",

  // ------------------------------ INTERFACE COUNTERS ------------------------------
  ACTION_SUGGESTION: "Sugerencias de acciones",
  DEVICES_WITH_INTERFACE_COUNTERS_INCREMENT: "Dispositivos que poseen incrementos de interface counters",
  INTERFACE_COUNTERS_LIST_HEADER: "Existen dispositivos con incremento de interface counters.",

  INTERFACE_COUNTERS_HEADER: "Incremento de Interface Counters",
  IN_DISCARDS_HEADER: "Incremento de In Discards",
  IN_ERRORS_HEADER: "Incremento de In Errors",
  IN_UNKNOWN_PROTOS_HEADER: "Incremento de In Unknown Protos",
  OUT_DISCARDS_HEADER: "Incremento de Out Discards",
  OUT_ERRORS_HEADER: "Incremento de Out Errors",
  INTERFACE_COUNTERS_NOT_SUPPORTED: "El dispositivo no soporta acceso a los interface counters",
  INTERFACE_COUNTERS_NOT_ANSWERED_YET: "El dispositivo aún no respondió",

  INTERFACE_COUNTERS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Interface Counters se sugiere:",
  INTERFACE_COUNTERS_SUGGESTION_2: "Navegar hasta la pestaña Interface Counters y hacer clic en el botón presente en la esquina superior derecha de la pantalla (según la imagen abajo) para descargar el PDF de sugerencias de acciones.",
  INTERFACE_COUNTERS_SUGGESTION_3: "En el documento se presentan las posibles causas para el incremento de cada uno de los tipos de Interface Counters.",

  INTERFACE_COUNTERS_SUGGESTION_4: "Hacer clic en el botón abajo para descargar el PDF de sugerencias de acciones. En el documento se presentan las posibles causas para el incremento de cada uno de los tipos de Interface Counters.",

  DEVS_WITH_INTERFACE_COUNTERS_EXPLANATION_1: "En esta lista se muestran solo los dispositivos y respectivos puertos que poseen incremento en al menos un tipo de contador de interface counters.",
  DEVS_WITH_INTERFACE_COUNTERS_EXPLANATION_2: "Los contadores que tengan incremento estarán destacados con el color naranja.",

  NO_DEVICES_WITH_INTERFACE_COUNTERS_INCREMENT: "No existen dispositivos en la red con incremento de interface counters",

  // ---------------------------- FAULTS ----------------------------
  FAULTS_LIST_HEADER: "Existen dispositivos en falla en la red.",
  FAULTS_LIST_DESCR: "Por favor, verifique su red.",
  DEVICE_WITH_FAULT: "Dispositivo en falla",

  FAULT_SUGGESTION_1: "Cuando un dispositivo esté en falla se sugiere:",
  FAULT_SUGGESTION_2: "Verificar la alimentación del dispositivo;",
  FAULT_SUGGESTION_3: "Verificar si está conectado físicamente a la red;",
  FAULT_SUGGESTION_4: "Verificar la integridad del cable;",
  FAULT_SUGGESTION_5: "Verificar si el dispositivo perdió su dirección IP.",

  NO_DEVICE_WITH_FAULT: "No existen dispositivos en la red con fallas",

  // ---------------------------- LOST IP ----------------------------
  LOST_IP_LIST_HEADER: "Existen dispositivos con posible pérdida de IP en la red.",
  LOST_IP_DESCR: "Por favor, verifique su red.",
  DEVICE_WITH_LOST_IP: "Dispositivo con posible pérdida de IP",

  LOST_IP_SUGGESTION_1: "Cuando un dispositivo presente posible pérdida de IP se sugiere:",
  LOST_IP_SUGGESTION_2: "Verificar las direcciones físicas, MAC, para identificar los dispositivos que presentan conflicto de dirección IP y corregir las configuraciones de esta dirección.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DUPLICATE_IP_PAGE_TITLE: ". - IP Duplicada",
  AVG_PING_EXCEEDED_PAGE_TITLE: ". - Límite de ping excedido",
  DHCP_CONFIG_METHOD_PAGE_TITLE: ". - Método de configuración DHCP",
  PACKET_LOSS_GREATER_ONE_PERCENT_PAGE_TITLE: ". - % de pings perdidos por encima de la tasa límite",
  INACTIVE_PORT_PAGE_TITLE: ". - Puerto desactivado",
  AUTONEGOTIATION_FAILED_PAGE_TITLE: ". - La autonegociación falló",
  PORT_NOT_IN_FULL_DUPLEX_PAGE_TITLE: ". - Puerto no configurado en modo Full Duplex",
  INTERFACE_SPEED_LESSER_THAN_100_PAGE_TITLE: ". - Velocidad de la interfaz < 100 Mbps",
  PORT_WITH_LOCAL_HARDWARE_FAULT_PAGE_TITLE: ". - Puerto con falla de hardware local",
  ADDR_CONFLICT_DETECTED_PAGE_TITLE: ". - Conflicto de dirección detectado",
  TS_EXPERT_MEDIA_COUNTERS_PAGE_TITLE: ". - Media Counters",
  TS_EXPERT_INTERFACE_COUNTERS_PAGE_TITLE: ". - Interface Counters",
  FAULT_PAGE_TITLE: ". - Dispositivo en falla",
  LOST_IP_PAGE_TITLE: ". - Dispositivo con posible pérdida de IP",

  DUPLICATE_IP_DOTS: "..................................................................................................................................",
  AVG_PING_EXCEEDED_DOTS: "................................................................................................................",
  DHCP_CONFIG_METHOD_DOTS: "...................................................................................................",
  PACKET_LOSS_GREATER_ONE_PERCENT_DOTS: ".......................................................................",
  INACTIVE_PORT_DOTS: ".......................................................................................................................",
  AUTONEGOTIATION_FAILED_DOTS: "...............................................................................................................",
  PORT_NOT_IN_FULL_DUPLEX_DOTS: "................................................................................",
  INTERFACE_SPEED_LESSER_THAN_100_DOTS: "............................................................................................",
  PORT_WITH_LOCAL_HARDWARE_FAULT_DOTS: "...............................................................................................",
  ADDR_CONFLICT_DETECTED_DOTS: "..................................................................................................",
  TS_EXPERT_DISCLAIMER_DOTS: ".....................................................................................................................................",
  DEVICE_WITH_FAULT_DOTS: "......................................................................................................................",
  DEVICE_WITH_LOST_IP_DOTS: "......................................................................................... ",

  AVG_PING_EXCEEDED: "Límite de ping excedido",
  REGISTERED_PING: "Ping registrado",

  // ---------------------------- LOG ----------------------------
  HORARY: "Horario",
  EVENT: "Evento",
  INSERT_VALID_LOG_INPUT: "Por favor, escriba una IP, dirección MAC, nombre del producto o tipo de evento válido",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  SAVE: "Guardar",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Actualizando las configuraciones de TS Expert, espere un momento.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "Las configuraciones de TS Expert fueron guardadas con éxito.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocurrió un error al guardar las configuraciones de TS Expert.",

  TS_EXPERT_CONFIGURATION: "Configuraciones de TS Expert",

  CONFIG_DUPLICATE_IP_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que se detecte una IP duplicada en la red.",

  CONFIG_EXCEEDED_PING_LIST_HEADER: "Tiempo de ping excedido",
  CONFIG_EXCEEDED_PING_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que el ping promedio de un dispositivo exceda el valor límite de ping.",

  CONFIG_DHCP_LIST_HEADER: "DHCP",
  CONFIG_DHCP_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que el método de configuración de un dispositivo sea DHCP.",

  CONFIG_LOST_PINGS_LIST_HEADER: "Pings perdidos",
  CONFIG_LOST_PINGS_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que el % de pings perdidos de un dispositivo sea mayor que la tasa límite.",

  CONFIG_INACTIVE_PORT_LIST_HEADER: "Puerto desactivado",
  CONFIG_INACTIVE_PORT_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que un puerto activo de un dispositivo sea desactivado.",

  CONFIG_AUTO_NEGOTIATION_LIST_HEADER: "Puerto con problema de autonegociación",
  CONFIG_AUTO_NEGOTIATION_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que ocurra un problema en la autonegociación de un puerto",

  CONFIG_DUPLEX_LIST_HEADER: "Puerto no configurado en modo Full Duplex",
  CONFIG_DUPLEX_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que el modo duplex de un puerto no sea Full Duplex.",

  CONFIG_SLOW_SPEED_LIST_HEADER: "Puerto con velocidad de interfaz < 100 Mbps",
  CONFIG_SLOW_SPEED_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que la velocidad de la interfaz de un puerto sea < 100 Mbps.",

  CONFIG_LOCAL_HARDWARE_FAULT_LIST_HEADER: "Puerto con falla de hardware local",
  CONFIG_LOCAL_HARDWARE_FAULT_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que un puerto posea falla de hardware local.",

  CONFIG_ACD_LIST_HEADER: "ACD - Conflicto de dirección",
  CONFIG_ACD_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que un dispositivo detecte que hubo un conflicto de dirección.",

  CONFIG_MEDIA_COUNTERS_LIST_HEADER: "Media Counters",
  CONFIG_MEDIA_COUNTERS_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que un dispositivo posea incremento en el error de algún contador de la pantalla Media Counters.",

  CONFIG_INTERFACE_COUNTERS_LIST_HEADER: "Interface Counters",
  CONFIG_INTERFACE_COUNTERS_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las veces que un dispositivo posea incremento en el error de algún contador de la pantalla Interface Counters.",

  CONFIG_FAULTS_LIST_HEADER: "Fallas",
  CONFIG_FAULTS_LIST_CONTENT: "Si está encendido, TS Expert registrará cada vez que un dispositivo Ethernet/IP entre en estado de falla. Esto indica que no está respondiendo a comandos ping y arp en la red, es decir, no es accesible vía red.",

  CONFIG_LOST_IP_LIST_HEADER: "Pérdida de dirección IP",
  CONFIG_LOST_IP_LIST_CONTENT: "Si está encendido, TS Expert registrará cada vez que se detecte un dispositivo con posible pérdida de dirección IP (0.0.0.0).",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  EDIT_TOPOLOGY_POS_STRING: "Editar",
  SAVE_TOPOLOGY_POS_STRING: "Guardar",
  DELETE_TOPOLOGY_POS_STRING: "Eliminar",
  EXPORT_SVG: "SVG",

  EXPORT_TOPOLOGY: "Topología",
  IMPORT: "Importar",
  IMPORT_TOPOLOGY: "Importar topología",
  POSITION: "Posición",
  EXPORT: "Exportar",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "¡La posición de la topología se guardó correctamente!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocurrió el siguiente error al guardar la posición de la topología: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "¡La posición de la topología se eliminó correctamente!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocurrió el siguiente error al eliminar la posición de la topología: ",

  ASK_REMOVE_POSITIONING: "¿Está seguro de que desea eliminar la posición guardada?",
  REMOVE_POSITIONING: "Eliminar posición",

  YES: "Sí",
  NO: "No",

  ALERT_NOT_POSSIBLE_TO_EDIT: "No es posible editar los datos del maestro",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "No es posible editar los datos de TS Scope",
  ALERT_NOT_POSSIBLE_TO_DELETE: "No es posible eliminar un dispositivo de la Live List",
  ALERT_CHOOSE_DEVICE_TYPE: "Elija un tipo de dispositivo, por favor",
  ALERT_CHOOSE_DEVICE_TYPE_ERROR: "Solo se pueden editar dispositivos EtherNet/IP",
  ALERT_CHOOSE_CONNECTION_TYPE: "Seleccione un tipo de conexión, por favor",

  ADD_DEVICE: "Agregar dispositivo",
  TAG_PLACEHOLDER: "TAG (opcional)",

  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Elija un tipo de dispositivo",
  ADD_CONNECTION: "Agregar conexión",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Elija un tipo de conexión",
  EDIT_DEVICE: "Editar dispositivo",

  CANCEL: "Cancelar",
  ADD: "Agregar",

  SCANNER_NAME: "Scanner",
  DEVICE_NAME_LABEL: "Nombre: ",
  DEVICE_NAME: "Nombre del dispositivo",
  ACCESS_POINT_NAME: "Access Point",

  LOCALE_EDIT: "Editar",
  LOCALE_DEL: "Eliminar selección",
  LOCALE_BACK: "Volver",
  LOCALE_ADD_NODE: "Agregar dispositivo",
  LOCALE_ADD_EDGE: "Agregar conexión",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  LOCALE_EDIT_EDGE: "Editar conexión",
  LOCALE_ADD_DESCRIPTION: "Haga clic en un espacio vacío para agregar un nuevo dispositivo",
  LOCALE_EDGE_DESCRIPTION: "Haga clic en un dispositivo y arrastre la conexión hasta otro dispositivo para conectarlos",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Haga clic en los puntos de control y arrástrelos hasta un dispositivo para conectarlos",
  LOCALE_CREATE_EDGE_ERROR: "No es posible crear una conexión para un clúster",
  LOCALE_DELETE_CLUSTER_ERROR: "Los clústeres no se pueden eliminar",
  LOCALE_EDIT_CLUSTER_ERROR: "Los clústeres no se pueden editar",

  FORM_NO_DEVICE_FOUND_PREFIX: "No se encontró el dispositivo con dirección ",
  FORM_NO_DEVICE_FOUND_SUFFIX: "",

  INSERT_VALID_ADDRESS_OR_TAG: "Ingrese una dirección o tag válidos",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Ingrese una dirección, tag o modelo válidos",

  POSITIONING_CONFLICT_1: "Hay un conflicto en la información de los dispositivos con las direcciones:",
  POSITIONING_CONFLICT_2: "\nPor este motivo, sus posiciones y conexiones volverán al estado predeterminado.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Las posiciones y conexiones volvieron correctamente al estado predeterminado",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "Ocurrió el siguiente error al devolver las posiciones y conexiones al estado predeterminado: ",

  TOPOLOGY_IMPORT_SUCCESS: "¡La topología se importó correctamente!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocurrió un error al importar la topología gráfica: ",
  INVALID_OR_CORRUPT_FILE: "El archivo no es válido o está dañado.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Seleccione un archivo de topología, por favor.",

  COLORS_LABELS: "Leyenda de colores e iconos",
  LABEL_DEVICE_OK: ": Dispositivo EtherNet/IP con estado de comunicación correcto;",
  LABEL_DEVICE_INCREMENT_ERROR: ": Dispositivo EtherNet/IP con incremento de errores. Consulte la pantalla Interface Counters.",
  LABEL_DEVICE_FAULT: ": Dispositivo EtherNet/IP con falla de comunicación;",
  LABEL_NO_STATUS: ": Dispositivo sin estado;",
  LABEL_DEVICE_ONLINE: ": Dispositivo en línea;",
  ADDRESS: "Dirección",
  MASTER_FAULT_STRING: "Scanner",
  DRIVE: "Drive",
  SWITCH: "Switch",

  INVALID_INSERTED_IP: "La IP ingresada no es válida",

  FORM_INPUT_NOT_FOUND_1: "No se encontró el dispositivo con IP: ",
  FORM_INPUT_NOT_FOUND_2: "",
  FORM_INPUT_INVALID_IP: "Ingrese una dirección IP válida",






  DUPLICATE_IPS: "No se pudo cargar la topología gráfica porque la red contiene direcciones IP duplicadas.",


  // ---------------------------- MEDIA COUNTERS + INTERFACE COUNTERS REPORT ----------------------------
  GENERATING_ACTIONS_LIST_WAITING: "Generando PDF de lista de acciones, por favor espere.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generado con éxito. Para guardarlo, haga clic en guardar lista de acciones.",

  GENERATING_ACTIONS_SUGESTIONS_WAITING: "Generando PDF de sugerencias de acciones, por favor espere.",
  GENERATING_ACTIONS_SUGGESTIONS_SUCCESS: "PDF generado con éxito. Para guardarlo, haga clic en guardar sugerencias de acciones.",

  SUGGESTED_ACTIONS_HEADER_TEXT: "Sugerencias de acciones - Media / Interface Counters",

  COMMON_CAUSES: "Causas comunes: ",

  ALIGNMENT_ERRORS_DOTS: "..................................................................................................",
  CARRIER_SENSE_ERRORS_DOTS: ".............................................................................................",
  FCS_ERRORS_DOTS: ".............................................................................................................",
  SINGLE_COLLISIONS_DOTS: "...................................................................................................",
  MULTIPLE_COLLISIONS_DOTS: "................................................................................................",
  LATE_COLLISIONS_DOTS: "......................................................................................................",
  EXCESSIVE_COLLISIONS_DOTS: ".............................................................................................",
  DEFERRED_TRANSMISSIONS_DOTS: ".......................................................................................",
  FRAME_TOO_LONG_DOTS: "....................................................................................................",
  MAC_TRANSMIT_ERRORS_DOTS: "..........................................................................................",
  MAC_RECEIVE_ERRORS_DOTS: "............................................................................................",

  IN_DISCARDS_DOTS: "..........................................................................................................",
  IN_ERRORS_DOTS: "...............................................................................................................",
  IN_UNKNOWN_PROTOS_DOTS: ".............................................................................................",
  OUT_DISCARDS_DOTS: ".......................................................................................................",
  OUT_ERRORS_DOTS: "............................................................................................................",
  DEVS_WITH_INTERFACE_COUNTERS_DOTS: ".....................................................................",
  INTEFACE_COUNTERS_DISCLAIMER_DOTS: "....................................................................................................................................",

  ALIGNMENT_ERRORS_PAGE_TITLE: "1. - Incremento de Alignment Errors",
  CARRIER_SENSE_ERRORS_PAGE_TITLE: "2. - Incremento de Carrier Sense Errors",
  FCS_ERRORS_PAGE_TITLE: "3. - Incremento de FCS Errors",
  SINGLE_COLLISIONS_PAGE_TITLE: "4. - Incremento de Single Collisions",
  MULTIPLE_COLLISIONS_PAGE_TITLE: "5. - Incremento de Multiple Collisions",
  LATE_COLLISIONS_PAGE_TITLE: "6. - Incremento de Late Collisions",
  EXCESSIVE_COLLISIONS_PAGE_TITLE: "7. - Incremento de Excessive Collisions",
  DEFERRED_TRANSMISSIONS_PAGE_TITLE: "8. - Incremento de Deferred Transmissions",
  FRAME_TOO_LONG_PAGE_TITLE: "9. - Incremento de Frame Too Long",
  MAC_TRANSMIT_ERRORS_PAGE_TITLE: "10. - Incremento de MAC Transmit Errors",
  MAC_RECEIVE_ERRORS_PAGE_TITLE: "11. - Incremento de MAC Receive Errors",
  IN_DISCARDS_PAGE_TITLE: "12. - Incremento de In Discards",
  IN_ERRORS_PAGE_TITLE: "13. - Incremento de In Errors",
  IN_UNKNOWN_PROTOS_PAGE_TITLE: "14. - Incremento de In Unknown Protos",
  OUT_DISCARDS_PAGE_TITLE: "15. - Incremento de Out Discards",
  OUT_ERRORS_PAGE_TITLE: "16. - Incremento de Out Errors",

  ALIGNMENT_ERRORS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Alignment Errors se sugiere:",
  ALIGNMENT_ERRORS_DP: "Alignment Errors: ",
  ALIGNMENT_ERRORS_SUGGESTION_2: "Son paquetes recibidos sin un número par de octetos y con problemas de CRC.",
  ALIGNMENT_ERRORS_SUGGESTION_3: "Usualmente son resultado de incompatibilidad de Duplex o problemas en el medio físico, como cableado, puertos o placa electrónica de red. Al conectar cables por primera vez este tipo de error puede ocurrir.",

  CARRIER_SENSE_ERRORS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Carrier Sense Errors se sugiere:",
  CARRIER_SENSE_DP: "Carrier Sense: ",
  CARRIER_SENSE_ERRORS_SUGGESTION_2: "El parámetro se incrementa cada vez que el controlador de red Ethernet intenta enviar un paquete. La interfaz de red “escucha” el medio físico y verifica si no está siendo utilizado antes de enviar el paquete.",
  CARRIER_SENSE_ERRORS_SUGGESTION_3: "Estos eventos ocurren en operación normal en enlaces configurados como Half Duplex. Si el enlace está configurado como Full Duplex indica un problema en el cableado, en la tarjeta de red interna o en el propio puerto Ethernet.",

  FCS_ERRORS_SUGGESTION_1: "Cuando un dispositivo posea incremento de FCS Errors se sugiere:",
  FCS_ERRORS_DP: "FCS Errors (CRC incorrecto): ",
  FCS_ERRORS_SUGGESTION_2: "Indica el número de veces que un paquete con tamaño correcto presentó resultados diferentes entre el checksum enviado y el recibido.",
  FCS_ERRORS_SUGGESTION_3: "Usualmente indica problemas en el medio físico, como interferencias, problemas en el cableado o en las interfaces de red que interconectan los equipos. Los errores de CRC también pueden originarse por colisiones e incompatibilidad de Duplex.",

  SINGLE_COLLISIONS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Single Collisions se sugiere:",
  MULTIPLE_COLLISIONS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Multiple Collisions se sugiere:",
  EXCESSIVE_COLLISIONS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Excessive Collisions se sugiere:",

  SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_DP: "Single/Multiple/Excessive Collisions: ",
  SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_2: "indica el número de veces que ocurrió una / múltiples / 16 colisión(es) antes del correcto envío de un paquete.",
  SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_3: "Las colisiones son normales en enlaces configurados en Half Duplex, pero no deben ocurrir en configuración Full Duplex. Si este parámetro aumenta significativamente debe verificarse si hay alto uso de ancho de banda (tráfico excesivo), problema de montaje en el cableado o incompatibilidad de Duplex.",

  LATE_COLLISIONS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Late Collisions se sugiere:",
  LATE_COLLISIONS_DP: "Late Collisions: ",
  LATE_COLLISIONS_SUGGESTION_2: "Indica el número de veces que ocurrió una colisión sin que los dispositivos hayan conseguido detectarla debido a una diferencia de tiempo.",
  LATE_COLLISIONS_SUGGESTION_3: "Cableados con alteraciones eléctricas y, más comúnmente, excesivamente largos causan Late Collisions. Tarjetas de red defectuosas pueden generar aumento de este parámetro o incompatibilidad de Duplex.",

  DEFERRED_TRANSMISSIONS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Deferred Transmissions se sugiere:",
  DEFERRED_TRANSMISSIONS_DP: "Deferred Transmissions: ",
  DEFERRED_TRANSMISSIONS_SUGGESTION_2: "Indica el número de veces que un paquete fue enviado con retraso debido al tráfico en la red y no presentó errores o colisiones.",
  DEFERRED_TRANSMISSIONS_SUGGESTION_3: "Principalmente exceso de tráfico, siendo necesario reducir el tráfico en el puerto que presenta este error o reorganizar la topología de red.",

  FRAME_TOO_LONG_SUGGESTION_1: "Cuando un dispositivo posea incremento de Frame Too Long se sugiere:",
  FRAME_TOO_LONG_DP: "Frame too long: ",
  FRAME_TOO_LONG_SUGGESTION_2: "Indica el número de veces que un paquete Ethernet excedió el tamaño permitido.",
  FRAME_TOO_LONG_SUGGESTION_3: "Tamaño excesivo del paquete Ethernet o número excesivo de informaciones como TAGs.",

  MAC_TRANSMIT_ERRORS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Mac Transmit Error se sugiere:",
  MAC_TRANSMIT_ERROR_DP: "MAC Transmit Error: ",
  MAC_TRANSMIT_ERRORS_SUGGESTION_2: "Indica el número de veces que un paquete cuya transmisión por una interfaz presentó un error en la subcapa MAC. Solo se contabilizan si los parámetros late collisions, excessive collisions o carrier sense no son contabilizados para determinado paquete.",
  MAC_TRANSMIT_ERRORS_SUGGESTION_3: "Posible problema de hardware en la tarjeta de red.",

  MAC_RECEIVE_ERRORS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Mac Receive Error se sugiere:",
  MAC_RECEIVE_ERROR_DP: "MAC Receive Error: ",
  MAC_RECEIVE_ERRORS_SUGGESTION_2: "Indica el número de veces que un paquete cuya recepción por una interfaz presentó un error en la subcapa MAC. Solo se contabilizan si los parámetros frame too long, alignment o FCS Errors no son contabilizados para determinado paquete.",
  MAC_RECEIVE_ERRORS_SUGGESTION_3: "Posible problema de hardware en la tarjeta de red.",

  IN_DISCARDS_SUGGESTION_1: "Cuando un dispositivo posea incremento de In Discards se sugiere:",
  IN_DISCARDS_SUGGESTION_2: "• Verificar el uso de ancho de banda en el puerto donde están ocurriendo los descartes;",
  IN_DISCARDS_SUGGESTION_3: "• Verificar si hay alto uso de memoria y CPU en gateways, switches y demás equipos. Usualmente estos paquetes son descartados para liberar espacio de buffers internos de equipos sobrecargados;",
  IN_DISCARDS_SUGGESTION_4: "• Verificar configuraciones de control de flujo o ACL (Address Control List);",
  IN_DISCARDS_SUGGESTION_5: "• Protocolos desconocidos (en algunos casos) pueden estar circulando y no ser soportados;",
  IN_DISCARDS_SUGGESTION_6: "• Verificar si el puerto está bloqueado por alteración en la topología por el protocolo STP (Spanning Tree Protocol).",

  IN_ERRORS_SUGGESTION_1: "Cuando un dispositivo posea incremento de In Errors se sugiere:",
  IN_ERRORS_SUGGESTION_2: "• Verificar si hay un problema de Duplex (un puerto 100 Mbps Full Duplex conectado a un puerto 10 Mbps Half Duplex). Los enlaces deben tener la misma configuración en ambos extremos y, preferentemente, utilizar autonegociación;",
  IN_ERRORS_SUGGESTION_3: "• Verificar si las rutas de los cables de datos en bandejas, ductos y canaletas están próximas a cableado de potencia, drives y demás equipos de mayor consumo cuyo cableado pueda generar interferencia. Los cables de red deben estar lo más alejados posible o en ductos aislados y aterrizados;",
  IN_ERRORS_SUGGESTION_4: "• Verificar la calidad de los enlaces Ethernet. Conectores mal montados, cables y conectores de baja calidad pueden generar pérdidas;",
  IN_ERRORS_SUGGESTION_5: "• Usando certificador, verificar si los cables están íntegros y con capacidad de desempeño para la categoría (Cat5, Cat5e, Cat6, etc.).",

  IN_UNKNOWN_PROTOS_SUGGESTION_1: "Cuando un dispositivo posea incremento de In Unknown Protos se sugiere:",
  IN_UNKNOWN_PROTOS_DP: "In Unknown Protos: ",
  IN_UNKNOWN_PROTOS_SUGGESTION_2: "Indica el número de paquetes con protocolo desconocido recibidos por el equipo. El incremento de este parámetro indica la presencia de tráfico de protocolo no conocido en la red.",
  IN_UNKNOWN_PROTOS_SUGGESTION_3: "Buscar equipos y softwares desconocidos en la red que puedan estar realizando estos envíos.",

  OUT_DISCARDS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Out Discards se sugiere:",
  OUT_DISCARDS_SUGGESTION_2: "Verificar si hay alto uso de memoria y CPU en gateways, switches y demás equipos. Usualmente estos paquetes son descartados para liberar espacio de buffers internos de equipos sobrecargados.",

  OUT_ERRORS_SUGGESTION_1: "Cuando un dispositivo posea incremento de Out Errors se sugiere:",
  OUT_ERRORS_SUGGESTION_2: "• Verificar si hay un problema de Duplex (un puerto 100 Mbps Full Duplex conectado a un puerto 10 Mbps Half Duplex). Los enlaces deben tener la misma configuración en ambos extremos y, preferentemente, utilizar autonegociación;",
  OUT_ERRORS_SUGGESTION_3: "• Verificar la calidad de los enlaces Ethernet. Conectores mal montados, cables y conectores de baja calidad pueden generar pérdidas;",
  OUT_ERRORS_SUGGESTION_4: "• Verificar posibles problemas en la interfaz de red del equipo, siendo necesaria su sustitución en caso de ser detectados.",

  MODEL: "Modelo",
  SUGGESTED_ACTIONS_BUTTON: "Sugerencias de acciones (PDF)",
  DESSELECT_ALL: "Deseleccionar todos",
  SAVE_REPORT: "Guardar informe",
  LESS_THAN_A_MINUTE: "< de 1 minuto",
  SUGGESTED_ACTIONS_FILENAME: "Sugerencias de acciones.pdf",
  FINISHING: "Finalizando...",
  SAVE_SUGGESTED_ACTIONS: "Guardar sugerencias de acciones",
  TS_EXPERT_REPORT_FILENAME: "Lista de acciones - TS Expert - Ethernet_IP.pdf",
  SAVE_ACTIONS_LIST: "Guardar lista de acciones",
  UNRESOLVED_PROBLEM_DUPLICATE_IP: "No fue posible verificar los eventos de los siguientes dispositivos porque aún tienen una IP duplicada:\n",
  UNRESOLVED_PROBLEM_PING: "No fue posible verificar los eventos de los siguientes dispositivos porque su ping promedio sigue por encima del límite configurado:\n",
  UNRESOLVED_PROBLEM_DHCP: "No fue posible verificar los eventos de los siguientes dispositivos porque siguen configurados mediante DHCP:\n",
  UNRESOLVED_PROBLEM_PACKET_LOSS: "No fue posible verificar los eventos de los siguientes dispositivos porque el porcentaje de pings perdidos sigue siendo igual o mayor que el límite:\n",
  UNRESOLVED_PROBLEM_INACTIVE_PORT: "No fue posible verificar los eventos de los siguientes dispositivos porque sus puertos permanecen inactivos:\n",
  UNRESOLVED_PROBLEM_AUTONEGOTIATION: "No fue posible verificar los eventos de los siguientes dispositivos porque sus puertos aún informan una falla de autonegociación:\n",
  UNRESOLVED_PROBLEM_DUPLEX: "No fue posible verificar los eventos de los siguientes dispositivos porque sus puertos no están configurados en Full Duplex:\n",
  UNRESOLVED_PROBLEM_INTERFACE_SPEED: "No fue posible verificar los eventos de los siguientes dispositivos porque la velocidad de interfaz permanece por debajo de 100 Mbps:\n",
  UNRESOLVED_PROBLEM_HARDWARE_FAULT: "No fue posible verificar los eventos de los siguientes dispositivos porque sus puertos aún tienen una falla de hardware local:\n",
  UNRESOLVED_PROBLEM_ADDRESS_CONFLICT: "No fue posible verificar los eventos de los siguientes dispositivos porque aún detectan un conflicto de dirección:\n",
  UNRESOLVED_PROBLEM_RETRY: "No fue posible verificar los eventos de los siguientes dispositivos. Inténtelo nuevamente:\n",
  UNRESOLVED_PROBLEM_FAULT: "No fue posible verificar los eventos de los siguientes dispositivos porque permanecen en estado de falla:\n",
  UNRESOLVED_PROBLEM_LOST_IP: "No fue posible verificar los eventos de los siguientes dispositivos porque aún muestran una posible pérdida de IP:\n",
  UNRESOLVED_PROBLEM_GENERIC: "No fue posible verificar los eventos de los siguientes dispositivos:",
  TS_EXPERT_ERROR_DEVICE: "Dispositivo:\n",
  TS_EXPERT_ERROR_DUPLICATE_IP: "• IP duplicada: ",
  TS_EXPERT_ERROR_IP: "• IP: ",
  TS_EXPERT_ERROR_MAC: "• MAC: ",
  TS_EXPERT_ERROR_AVERAGE_PING: "• Ping promedio: ",
  TS_EXPERT_ERROR_CONFIGURATION_METHOD: "• Método de configuración: ",
  TS_EXPERT_ERROR_LOST_PINGS: "• Pings perdidos (%): ",
  TS_EXPERT_ERROR_PORT: "• Puerto: ",
  TS_EXPERT_ERROR_NEGOTIATION_STATUS: "• Estado de negociación: ",
  TS_EXPERT_ERROR_DUPLEX_MODE: "• Modo dúplex: ",
  TS_EXPERT_ERROR_INTERFACE_SPEED: "• Velocidad de interfaz: ",
  TS_EXPERT_ERROR_LOCAL_HARDWARE_FAULT: "• Falla de hardware local: ",
  TS_EXPERT_ERROR_ACD_STATUS: "• ACD Status: ",
  INVENTORY_MENU: "Inventario",
  PORTS_MENU: "Puertos",
  NETWORK_MENU: "Red",
  PING_GRAPH_MENU: "Gráfico de ping",
  GRAPHIC_TOPOLOGY_MENU: "Topología gráfica",
  CONFIGURATIONS_MENU: "Configuraciones",
  CHART_MONTHS: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
  CHART_SHORT_MONTHS: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
  CHART_DAYS: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
  CHART_SHORT_DAYS: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
  CHART_DOWNLOAD_SVG: "Descargar SVG",
  CHART_DOWNLOAD_PNG: "Descargar PNG",
  CHART_DOWNLOAD_CSV: "Descargar CSV",
  CHART_DOWNLOAD: "Descargar",
  CHART_SELECT: "Seleccionar",
  CHART_SELECT_ZOOM: "Seleccionar zoom",
  CHART_ZOOM_IN: "Acercar",
  CHART_ZOOM_OUT: "Alejar",
  CHART_PAN: "Desplazar",
  CHART_RESET_ZOOM: "Restablecer zoom",
  PING_MILLISECONDS: "Ping (ms)",
  BATCH_CHECK_SUCCESS: "Todos los eventos se verificaron correctamente.",
  REPORT_PAGE: "Página",
  REPORT_PDF_FILENAME: "Informe TS Monitor EtherNet/IP.pdf",
  TS_EXPERT_REPORT_TITLE: "TS Expert:",
  TS_EXPERT_REPORT_ACTION_LIST: "Lista de acciones",
  SUGGESTED_ACTIONS_REPORT_TITLE: "Sugerencias de acciones:",
  SUGGESTED_ACTIONS_REPORT_SUBTITLE: "Media Counters e Interface Counters",
  RELATIVE_YEAR: "año",
  RELATIVE_MONTH: "mes",
  RELATIVE_MONTHS: "meses",
  RELATIVE_DAY: "día",
  RELATIVE_HOUR: "hora",
  RELATIVE_MINUTE: "minuto",
  REPORT_LEGEND: "Leyenda",
  REPORT_DUPLICATE_IP_LEGEND: "La celda IP de un dispositivo tendrá fondo morado si su IP está duplicada.",
  REPORT_DHCP_LEGEND: "La celda Método de configuración tendrá fondo azul oscuro si el método es DHCP.",
});

export default Strings;
